import { IconType } from './model/enum.model';

const distractions = 'assets/images/fleet-tracker/violations/distractions';
const unspecifiedHeadingPath = 'assets/images/fleet-tracker/unspecified-heading';
const livePath = 'assets/images/fleet-tracker/live';
const stoppedPath = 'assets/images/fleet-tracker/stopped';
const trailIconsPath = './../../assets/images/fleet-tracker/trail';
const addressPath = './../../assets/images/fleet-tracker/address';
const violationPath = 'assets/images/fleet-tracker/violation';
const breadcrumbPath = 'assets/images/fleet-tracker/violation';
const eventCollisionPath = 'assets/images/fleet-tracker/event-collision';
const eventPath = 'assets/images/fleet-tracker/event';
const followingDistancePath = 'assets/images/fleet-tracker/following-distance';
const geofencePath = './../../assets/images/fleet-tracker/geofence';
const movingPath = './../../assets/images/fleet-tracker/moving';
const idlePath = 'assets/images/fleet-tracker/idle';
const laneDeparturePath = 'assets/images/fleet-tracker/lane-departure';
const speedingPath = 'assets/images/fleet-tracker/speeding';
const tripPath = 'assets/images/fleet-tracker/trip';
const unsupportedPath = 'assets/images/fleet-tracker/unsupported';
const reallyStalePath = 'assets/images/fleet-tracker/really-stale';
const stalePath = 'assets/images/fleet-tracker/stale';
const callOutPath = 'assets/images/fleet-tracker/call-out';
const riskPath = 'assets/images/fleet-tracker/risk';
const trafficCamActive = 'assets/images/fleet-tracker/traffic-cam/active';
const trafficCamInactive = 'assets/images/fleet-tracker/traffic-cam/inactive';
const assetPath = 'assets/images/fleet-tracker/asset';
const virtualCamPath = 'assets/images/fleet-tracker/virtual-cam';

// Text encoded data URLs eliminate the need for external resource dependencies.
// They also contribute to the size of the generated application bundle and the
// costs are starting to outweigh the benefits of self-containment.
//
// Starting with distraction icons, we can start to externalize image links under
// the assets folder. We will supply the default icons that applications can then
// drop into their own application's assets folder.
//
// NOTE: See Colin Christ or Rod Macpherson for details and historical context.
//

const iconLinks1 = new Map<IconType, string>([
    [IconType.DistractionPhone, `${ distractions }/phone.png`],
    [IconType.RollingStopAlert, `${ distractions }/rolling-stop-alert.icon.png`],
    [IconType.FoodDrinkAlert, `${ distractions }/food-drink-alert.icon.png`],
    [IconType.UnbeltedAlert, `${ distractions }/unbelted-alert.icon.png`],
    [IconType.SmokingAlert, `${ distractions }/smoking-alert.icon.png`],
    [IconType.ObstructionAlert, `${ distractions }/obstruction-alert.icon.png`],
    [IconType.MotionAlert, `${ distractions }/motion-alert.icon.png`],
    [IconType.UnspecifiedHeading, `${ unspecifiedHeadingPath }/unspecified-heading.sprites.png`],
    [IconType.Live, `${ livePath }/live.sprites.png`],
    [IconType.Stale, `${ stalePath }/stale.sprites.png`],
    [IconType.Stopped, `${ stoppedPath }/stopped.sprites.png`],
    [IconType.Trail, `${ trailIconsPath }/trail.sprites.png`],
    [IconType.Address, `${ addressPath }/address.icon.png`],
    [IconType.Violation, `${ violationPath }/violation.sprites.png`],
    [IconType.BreadCrumb, `${ breadcrumbPath }/breadcrumb.icon.png`],
    [IconType.EventCollision, `${ eventCollisionPath }/event-collision.icon.png`],
    [IconType.EventManual, `${ eventPath }/event-manual.icon.png`],
    [IconType.EventRecorded, `${ eventPath }/event-recorded.icon.png`],
    [IconType.EventRisky, `${ eventPath }/event-risky.icon.png`],
    [IconType.FollowingDistance, `${ followingDistancePath }/following-distance.icon.png`],
    [IconType.GeofenceInEnd, `${ geofencePath }/geofence-in-end.icon.png`],
    [IconType.GeofenceInStart, `${ geofencePath }/geofence-in-start.icon.png`],
    [IconType.GeofenceOutEnd, `${ geofencePath }/geofence-out-end.icon.png`],
    [IconType.GeofenceOutStart, `${ geofencePath }/geofence-out-start.icon.png`],
    [IconType.GeofenceIcon, `${ geofencePath }/geofence-icon.png`],
    [IconType.GeofenceIconUnlabled, `${ geofencePath }/geofence.icon.png`],
    [IconType.IdleMarker, `${ idlePath }/idle-marker.icon.png`],
    [IconType.IdleViolation, `${ idlePath }/idle-violation.icon.png`],
    [IconType.LanedepartureMarker, `${ laneDeparturePath }/lane-departure-marker.icon.png`],
    [IconType.Idle, `${ idlePath }/idle.sprites.png`],
    [IconType.SpeedingMarker, `${ speedingPath }/speeding-marker.icon.png`],
    [IconType.TripEndLeft, `${ tripPath }/trip-end-left.icon.png`],
    [IconType.TripEnd, `${ tripPath }/trip-end.icon.png`],
    [IconType.TripEndBlank, `${ tripPath }/trip-end-blank.icon.png`],
    [IconType.TripStartRight, `${ tripPath }/trip-start-right.icon.png`],
    [IconType.TripStart, `${ tripPath }/trip-start.icon.png`],
    [IconType.TripStartBlank, `${ tripPath }/trip-start-blank.icon.png`],
    [IconType.Trip, `${ tripPath }/trip.icon.png`],
    [IconType.UnsupportedIcon, `${ unsupportedPath }/unsupported.icon.png`],
    [IconType.Reallystale, `${ reallyStalePath }/really-stale.sprites.png`],
    [IconType.ReallystaleLabeled, `${ reallyStalePath }/really-stale-labeled.sprites.png`],
    [IconType.LiveOut, `${ livePath }/live-out.sprites.png`],
    [IconType.LiveIn, `${ livePath }/live-in.sprites.png`],
    [IconType.StoppedIn, `${ stoppedPath }/stopped-in.sprites.png`],
    [IconType.StoppedOut, `${ stoppedPath }/stopped-out.sprites.png`],
    [IconType.IdleOut, `${ idlePath }/idle-out.sprites.png`],
    [IconType.IdleIn, `${ idlePath }/idle-in.sprites.png`],
    [IconType.LiveLabeled, `${ livePath }/live-labeled.sprites.png`],
    [IconType.LiveInLabeled, `${ livePath }/live-in-labeled.sprites.png`],
    [IconType.LiveOutLabeled, `${ livePath }/live-out-labeled.sprites.png`],
    [IconType.IdleLabeled, `${ idlePath }/idle-labeled.sprites.png`],
    [IconType.IdleInLabeled, `${ idlePath }/idle-in-labeled.sprites.png`],
    [IconType.IdleOutLabeled, `${ idlePath }/idle-out-labeled.sprites.png`],
    [IconType.StoppedLabeled, `${ stoppedPath }/stopped-labeled.sprites.png`],
    [IconType.StoppedInLabeled, `${ stoppedPath }/stopped-in-labeled.sprites.png`],
    [IconType.StoppedOutLabeled, `${ stoppedPath }/stopped-out-labeled.sprites.png`],
    [IconType.StaleLabeled, `${ stalePath }/stale-labeled.sprites.png`],
    [IconType.CallOut, `${ callOutPath }/call-out.icon.png`],
    [IconType.Live_in_0_0, `${ movingPath }/moving-in.00-00.png`],
    [IconType.Live_in_0_1, `${ movingPath }/moving-in.00-01.png`],
    [IconType.Live_in_0_2, `${ movingPath }/moving-in.00-02.png`],
    [IconType.Live_in_0_3, `${ movingPath }/moving-in.00-03.png`],
    [IconType.Live_in_0_4, `${ movingPath }/moving-in.00-04.png`],
    [IconType.Live_in_0_5, `${ movingPath }/moving-in.00-05.png`],
    [IconType.Live_in_0_6, `${ movingPath }/moving-in.00-06.png`],
    [IconType.Live_in_0_7, `${ movingPath }/moving-in.00-07.png`],
    [IconType.Live_in_0_8, `${ movingPath }/moving-in.00-08.png`],
    [IconType.Live_in_0_9, `${ movingPath }/moving-in.00-09.png`],
    [IconType.Live_in_0_10, `${ movingPath }/moving-in.00-10.png`],
    [IconType.Live_in_0_11, `${ movingPath }/moving-in.00-11.png`],
    [IconType.Live_in_0_12, `${ movingPath }/moving-in.00-12.png`],
    [IconType.Live_in_0_13, `${ movingPath }/moving-in.00-13.png`],
    [IconType.Live_in_0_14, `${ movingPath }/moving-in.00-14.png`],
    [IconType.Live_in_0_15, `${ movingPath }/moving-in.00-15.png`],
    [IconType.Live_in_0_16, `${ movingPath }/moving-in.00-16.png`],
    [IconType.Live_in_0_17, `${ movingPath }/moving-in.00-17.png`],
    [IconType.Live_in_0_18, `${ movingPath }/moving-in.00-18.png`],
    [IconType.Live_in_0_19, `${ movingPath }/moving-in.00-19.png`],
    [IconType.Live_in_0_20, `${ movingPath }/moving-in.00-20.png`],
    [IconType.Live_in_0_21, `${ movingPath }/moving-in.00-21.png`],
    [IconType.Live_in_0_22, `${ movingPath }/moving-in.00-22.png`],
    [IconType.Live_in_0_23, `${ movingPath }/moving-in.00-23.png`],
    [IconType.Live_in_0_24, `${ movingPath }/moving-in.00-24.png`],
    [IconType.Live_in_0_25, `${ movingPath }/moving-in.00-25.png`],
    [IconType.Live_in_0_26, `${ movingPath }/moving-in.00-26.png`],
    [IconType.Live_in_0_27, `${ movingPath }/moving-in.00-27.png`],
    [IconType.Live_in_0_28, `${ movingPath }/moving-in.00-28.png`],
    [IconType.Live_in_0_29, `${ movingPath }/moving-in.00-29.png`],
    [IconType.Live_in_0_30, `${ movingPath }/moving-in.00-30.png`],
    [IconType.Live_in_0_31, `${ movingPath }/moving-in.00-31.png`],
    [IconType.Live_in_0_32, `${ movingPath }/moving-in.00-32.png`],
    [IconType.Live_in_0_33, `${ movingPath }/moving-in.00-33.png`],
    [IconType.Live_in_0_34, `${ movingPath }/moving-in.00-34.png`],
    [IconType.Live_in_0_35, `${ movingPath }/moving-in.00-35.png`],
    [IconType.Live_in_1_0, `${ movingPath }/moving-in.01-00.png`],
    [IconType.Live_in_1_1, `${ movingPath }/moving-in.01-01.png`],
    [IconType.Live_in_1_2, `${ movingPath }/moving-in.01-02.png`],
    [IconType.Live_in_1_3, `${ movingPath }/moving-in.01-03.png`],
    [IconType.Live_in_1_4, `${ movingPath }/moving-in.01-04.png`],
    [IconType.Live_in_1_5, `${ movingPath }/moving-in.01-05.png`],
    [IconType.Live_in_1_6, `${ movingPath }/moving-in.01-06.png`],
    [IconType.Live_in_1_7, `${ movingPath }/moving-in.01-07.png`],
    [IconType.Live_in_1_8, `${ movingPath }/moving-in.01-08.png`],
    [IconType.Live_in_1_9, `${ movingPath }/moving-in.01-09.png`],
    [IconType.Live_in_1_10, `${ movingPath }/moving-in.01-10.png`],
    [IconType.Live_in_1_11, `${ movingPath }/moving-in.01-11.png`],
    [IconType.Live_in_1_12, `${ movingPath }/moving-in.01-12.png`],
    [IconType.Live_in_1_13, `${ movingPath }/moving-in.01-13.png`],
    [IconType.Live_in_1_14, `${ movingPath }/moving-in.01-14.png`],
    [IconType.Live_in_1_15, `${ movingPath }/moving-in.01-15.png`],
    [IconType.Live_in_1_16, `${ movingPath }/moving-in.01-16.png`],
    [IconType.Live_in_1_17, `${ movingPath }/moving-in.01-17.png`],
    [IconType.Live_in_1_18, `${ movingPath }/moving-in.01-18.png`],
    [IconType.Live_in_1_19, `${ movingPath }/moving-in.01-19.png`],
    [IconType.Live_in_1_20, `${ movingPath }/moving-in.01-20.png`],
    [IconType.Live_in_1_21, `${ movingPath }/moving-in.01-21.png`],
    [IconType.Live_in_1_22, `${ movingPath }/moving-in.01-22.png`],
    [IconType.Live_in_1_23, `${ movingPath }/moving-in.01-23.png`],
    [IconType.Live_in_1_24, `${ movingPath }/moving-in.01-24.png`],
    [IconType.Live_in_1_25, `${ movingPath }/moving-in.01-25.png`],
    [IconType.Live_in_1_26, `${ movingPath }/moving-in.01-26.png`],
    [IconType.Live_in_1_27, `${ movingPath }/moving-in.01-27.png`],
    [IconType.Live_in_1_28, `${ movingPath }/moving-in.01-28.png`],
    [IconType.Live_in_1_29, `${ movingPath }/moving-in.01-29.png`],
    [IconType.Live_in_1_30, `${ movingPath }/moving-in.01-30.png`],
    [IconType.Live_in_1_31, `${ movingPath }/moving-in.01-31.png`],
    [IconType.Live_in_1_32, `${ movingPath }/moving-in.01-32.png`],
    [IconType.Live_in_1_33, `${ movingPath }/moving-in.01-33.png`],
    [IconType.Live_in_1_34, `${ movingPath }/moving-in.01-34.png`],
    [IconType.Live_in_1_35, `${ movingPath }/moving-in.01-35.png`],
    [IconType.Live_in_2_0, `${ movingPath }/moving-in.02-00.png`],
    [IconType.Live_in_2_1, `${ movingPath }/moving-in.02-01.png`],
    [IconType.Live_in_2_2, `${ movingPath }/moving-in.02-02.png`],
    [IconType.Live_in_2_3, `${ movingPath }/moving-in.02-03.png`],
    [IconType.Live_in_2_4, `${ movingPath }/moving-in.02-04.png`],
    [IconType.Live_in_2_5, `${ movingPath }/moving-in.02-05.png`],
    [IconType.Live_in_2_6, `${ movingPath }/moving-in.02-06.png`],
    [IconType.Live_in_2_7, `${ movingPath }/moving-in.02-07.png`],
    [IconType.Live_in_2_8, `${ movingPath }/moving-in.02-08.png`],
    [IconType.Live_in_2_9, `${ movingPath }/moving-in.02-09.png`],
    [IconType.Live_in_2_10, `${ movingPath }/moving-in.02-10.png`],
    [IconType.Live_in_2_11, `${ movingPath }/moving-in.02-11.png`],
    [IconType.Live_in_2_12, `${ movingPath }/moving-in.02-12.png`],
    [IconType.Live_in_2_13, `${ movingPath }/moving-in.02-13.png`],
    [IconType.Live_in_2_14, `${ movingPath }/moving-in.02-14.png`],
    [IconType.Live_in_2_15, `${ movingPath }/moving-in.02-15.png`],
    [IconType.Live_in_2_16, `${ movingPath }/moving-in.02-16.png`],
    [IconType.Live_in_2_17, `${ movingPath }/moving-in.02-17.png`],
    [IconType.Live_in_2_18, `${ movingPath }/moving-in.02-18.png`],
    [IconType.Live_in_2_19, `${ movingPath }/moving-in.02-19.png`],
    [IconType.Live_in_2_20, `${ movingPath }/moving-in.02-20.png`],
    [IconType.Live_in_2_21, `${ movingPath }/moving-in.02-21.png`],
    [IconType.Live_in_2_22, `${ movingPath }/moving-in.02-22.png`],
    [IconType.Live_in_2_23, `${ movingPath }/moving-in.02-23.png`],
    [IconType.Live_in_2_24, `${ movingPath }/moving-in.02-24.png`],
    [IconType.Live_in_2_25, `${ movingPath }/moving-in.02-25.png`],
    [IconType.Live_in_2_26, `${ movingPath }/moving-in.02-26.png`],
    [IconType.Live_in_2_27, `${ movingPath }/moving-in.02-27.png`],
    [IconType.Live_in_2_28, `${ movingPath }/moving-in.02-28.png`],
    [IconType.Live_in_2_29, `${ movingPath }/moving-in.02-29.png`],
    [IconType.Live_in_2_30, `${ movingPath }/moving-in.02-30.png`],
    [IconType.Live_in_2_31, `${ movingPath }/moving-in.02-31.png`],
    [IconType.Live_in_2_32, `${ movingPath }/moving-in.02-32.png`],
    [IconType.Live_in_2_33, `${ movingPath }/moving-in.02-33.png`],
    [IconType.Live_in_2_34, `${ movingPath }/moving-in.02-34.png`],
    [IconType.Live_in_2_35, `${ movingPath }/moving-in.02-35.png`],
    [IconType.Live_in_3_0, `${ movingPath }/moving-in.03-00.png`],
    [IconType.Live_in_3_1, `${ movingPath }/moving-in.03-01.png`],
    [IconType.Live_in_3_2, `${ movingPath }/moving-in.03-02.png`],
    [IconType.Live_in_3_3, `${ movingPath }/moving-in.03-03.png`],
    [IconType.Live_in_3_4, `${ movingPath }/moving-in.03-04.png`],
    [IconType.Live_in_3_5, `${ movingPath }/moving-in.03-05.png`],
    [IconType.Live_in_3_6, `${ movingPath }/moving-in.03-06.png`],
    [IconType.Live_in_3_7, `${ movingPath }/moving-in.03-07.png`],
    [IconType.Live_in_3_8, `${ movingPath }/moving-in.03-08.png`],
    [IconType.Live_in_3_9, `${ movingPath }/moving-in.03-09.png`],
    [IconType.Live_in_3_10, `${ movingPath }/moving-in.03-10.png`],
    [IconType.Live_in_3_11, `${ movingPath }/moving-in.03-11.png`],
    [IconType.Live_in_3_12, `${ movingPath }/moving-in.03-12.png`],
    [IconType.Live_in_3_13, `${ movingPath }/moving-in.03-13.png`],
    [IconType.Live_in_3_14, `${ movingPath }/moving-in.03-14.png`],
    [IconType.Live_in_3_15, `${ movingPath }/moving-in.03-15.png`],
    [IconType.Live_in_3_16, `${ movingPath }/moving-in.03-16.png`],
    [IconType.Live_in_3_17, `${ movingPath }/moving-in.03-17.png`],
    [IconType.Live_in_3_18, `${ movingPath }/moving-in.03-18.png`],
    [IconType.Live_in_3_19, `${ movingPath }/moving-in.03-19.png`],
    [IconType.Live_in_3_20, `${ movingPath }/moving-in.03-20.png`],
    [IconType.Live_in_3_21, `${ movingPath }/moving-in.03-21.png`],
    [IconType.Live_in_3_22, `${ movingPath }/moving-in.03-22.png`],
    [IconType.Live_in_3_23, `${ movingPath }/moving-in.03-23.png`],
    [IconType.Live_in_3_24, `${ movingPath }/moving-in.03-24.png`],
    [IconType.Live_in_3_25, `${ movingPath }/moving-in.03-25.png`],
    [IconType.Live_in_3_26, `${ movingPath }/moving-in.03-26.png`],
    [IconType.Live_in_3_27, `${ movingPath }/moving-in.03-27.png`],
    [IconType.Live_in_3_28, `${ movingPath }/moving-in.03-28.png`],
    [IconType.Live_in_3_29, `${ movingPath }/moving-in.03-29.png`],
    [IconType.Live_in_3_30, `${ movingPath }/moving-in.03-30.png`],
    [IconType.Live_in_3_31, `${ movingPath }/moving-in.03-31.png`],
    [IconType.Live_in_3_32, `${ movingPath }/moving-in.03-32.png`],
    [IconType.Live_in_3_33, `${ movingPath }/moving-in.03-33.png`],
    [IconType.Live_in_3_34, `${ movingPath }/moving-in.03-34.png`],
    [IconType.Live_in_3_35, `${ movingPath }/moving-in.03-35.png`],
    [IconType.Live_in_4_0, `${ movingPath }/moving-in.04-00.png`],
    [IconType.Live_in_4_1, `${ movingPath }/moving-in.04-01.png`],
    [IconType.Live_in_4_2, `${ movingPath }/moving-in.04-02.png`],
    [IconType.Live_in_4_3, `${ movingPath }/moving-in.04-03.png`],
    [IconType.Live_in_4_4, `${ movingPath }/moving-in.04-04.png`],
    [IconType.Live_in_4_5, `${ movingPath }/moving-in.04-05.png`],
    [IconType.Live_in_4_6, `${ movingPath }/moving-in.04-06.png`],
    [IconType.Live_in_4_7, `${ movingPath }/moving-in.04-07.png`],
    [IconType.Live_in_4_8, `${ movingPath }/moving-in.04-08.png`],
    [IconType.Live_in_4_9, `${ movingPath }/moving-in.04-09.png`],
    [IconType.Live_in_4_10, `${ movingPath }/moving-in.04-10.png`],
    [IconType.Live_in_4_11, `${ movingPath }/moving-in.04-11.png`],
    [IconType.Live_in_4_12, `${ movingPath }/moving-in.04-12.png`],
    [IconType.Live_in_4_13, `${ movingPath }/moving-in.04-13.png`],
    [IconType.Live_in_4_14, `${ movingPath }/moving-in.04-14.png`],
    [IconType.Live_in_4_15, `${ movingPath }/moving-in.04-15.png`],
    [IconType.Live_in_4_16, `${ movingPath }/moving-in.04-16.png`],
    [IconType.Live_in_4_17, `${ movingPath }/moving-in.04-17.png`],
    [IconType.Live_in_4_18, `${ movingPath }/moving-in.04-18.png`],
    [IconType.Live_in_4_19, `${ movingPath }/moving-in.04-19.png`],
    [IconType.Live_in_4_20, `${ movingPath }/moving-in.04-20.png`],
    [IconType.Live_in_4_21, `${ movingPath }/moving-in.04-21.png`],
    [IconType.Live_in_4_22, `${ movingPath }/moving-in.04-22.png`],
    [IconType.Live_in_4_23, `${ movingPath }/moving-in.04-23.png`],
    [IconType.Live_in_4_24, `${ movingPath }/moving-in.04-24.png`],
    [IconType.Live_in_4_25, `${ movingPath }/moving-in.04-25.png`],
    [IconType.Live_in_4_26, `${ movingPath }/moving-in.04-26.png`],
    [IconType.Live_in_4_27, `${ movingPath }/moving-in.04-27.png`],
    [IconType.Live_in_4_28, `${ movingPath }/moving-in.04-28.png`],
    [IconType.Live_in_4_29, `${ movingPath }/moving-in.04-29.png`],
    [IconType.Live_in_4_30, `${ movingPath }/moving-in.04-30.png`],
    [IconType.Live_in_4_31, `${ movingPath }/moving-in.04-31.png`],
    [IconType.Live_in_4_32, `${ movingPath }/moving-in.04-32.png`],
    [IconType.Live_in_4_33, `${ movingPath }/moving-in.04-33.png`],
    [IconType.Live_in_4_34, `${ movingPath }/moving-in.04-34.png`],
    [IconType.Live_in_4_35, `${ movingPath }/moving-in.04-35.png`],
    [IconType.Live_in_5_0, `${ movingPath }/moving-in.05-00.png`],
    [IconType.Live_in_5_1, `${ movingPath }/moving-in.05-01.png`],
    [IconType.Live_in_5_2, `${ movingPath }/moving-in.05-02.png`],
    [IconType.Live_in_5_3, `${ movingPath }/moving-in.05-03.png`],
    [IconType.Live_in_5_4, `${ movingPath }/moving-in.05-04.png`],
    [IconType.Live_in_5_5, `${ movingPath }/moving-in.05-05.png`],
    [IconType.Live_in_5_6, `${ movingPath }/moving-in.05-06.png`],
    [IconType.Live_in_5_7, `${ movingPath }/moving-in.05-07.png`],
    [IconType.Live_in_5_8, `${ movingPath }/moving-in.05-08.png`],
    [IconType.Live_in_5_9, `${ movingPath }/moving-in.05-09.png`],
    [IconType.Live_in_5_10, `${ movingPath }/moving-in.05-10.png`],
    [IconType.Live_in_5_11, `${ movingPath }/moving-in.05-11.png`],
    [IconType.Live_in_5_12, `${ movingPath }/moving-in.05-12.png`],
    [IconType.Live_in_5_13, `${ movingPath }/moving-in.05-13.png`],
    [IconType.Live_in_5_14, `${ movingPath }/moving-in.05-14.png`],
    [IconType.Live_in_5_15, `${ movingPath }/moving-in.05-15.png`],
    [IconType.Live_in_5_16, `${ movingPath }/moving-in.05-16.png`],
    [IconType.Live_in_5_17, `${ movingPath }/moving-in.05-17.png`],
    [IconType.Live_in_5_18, `${ movingPath }/moving-in.05-18.png`],
    [IconType.Live_in_5_19, `${ movingPath }/moving-in.05-19.png`],
    [IconType.Live_in_5_20, `${ movingPath }/moving-in.05-20.png`],
    [IconType.Live_in_5_21, `${ movingPath }/moving-in.05-21.png`],
    [IconType.Live_in_5_22, `${ movingPath }/moving-in.05-22.png`],
    [IconType.Live_in_5_23, `${ movingPath }/moving-in.05-23.png`],
    [IconType.Live_in_5_24, `${ movingPath }/moving-in.05-24.png`],
    [IconType.Live_in_5_25, `${ movingPath }/moving-in.05-25.png`],
    [IconType.Live_in_5_26, `${ movingPath }/moving-in.05-26.png`],
    [IconType.Live_in_5_27, `${ movingPath }/moving-in.05-27.png`],
    [IconType.Live_in_5_28, `${ movingPath }/moving-in.05-28.png`],
    [IconType.Live_in_5_29, `${ movingPath }/moving-in.05-29.png`],
    [IconType.Live_in_5_30, `${ movingPath }/moving-in.05-30.png`],
    [IconType.Live_in_5_31, `${ movingPath }/moving-in.05-31.png`],
    [IconType.Live_in_5_32, `${ movingPath }/moving-in.05-32.png`],
    [IconType.Live_in_5_33, `${ movingPath }/moving-in.05-33.png`],
    [IconType.Live_in_5_34, `${ movingPath }/moving-in.05-34.png`],
    [IconType.Live_in_5_35, `${ movingPath }/moving-in.05-35.png`],
    [IconType.Live_in_6_0, `${ movingPath }/moving-in.06-00.png`],
    [IconType.Live_in_6_1, `${ movingPath }/moving-in.06-01.png`],
    [IconType.Live_in_6_2, `${ movingPath }/moving-in.06-02.png`],
    [IconType.Live_in_6_3, `${ movingPath }/moving-in.06-03.png`],
    [IconType.Live_in_6_4, `${ movingPath }/moving-in.06-04.png`],
    [IconType.Live_in_6_5, `${ movingPath }/moving-in.06-05.png`],
    [IconType.Live_in_6_6, `${ movingPath }/moving-in.06-06.png`],
    [IconType.Live_in_6_7, `${ movingPath }/moving-in.06-07.png`],
    [IconType.Live_in_6_8, `${ movingPath }/moving-in.06-08.png`],
    [IconType.Live_in_6_9, `${ movingPath }/moving-in.06-09.png`],
    [IconType.Live_in_6_10, `${ movingPath }/moving-in.06-10.png`],
    [IconType.Live_in_6_11, `${ movingPath }/moving-in.06-11.png`],
    [IconType.Live_in_6_12, `${ movingPath }/moving-in.06-12.png`],
    [IconType.Live_in_6_13, `${ movingPath }/moving-in.06-13.png`],
    [IconType.Live_in_6_14, `${ movingPath }/moving-in.06-14.png`],
    [IconType.Live_in_6_15, `${ movingPath }/moving-in.06-15.png`],
    [IconType.Live_in_6_16, `${ movingPath }/moving-in.06-16.png`],
    [IconType.Live_in_6_17, `${ movingPath }/moving-in.06-17.png`],
    [IconType.Live_in_6_18, `${ movingPath }/moving-in.06-18.png`],
    [IconType.Live_in_6_19, `${ movingPath }/moving-in.06-19.png`],
    [IconType.Live_in_6_20, `${ movingPath }/moving-in.06-20.png`],
    [IconType.Live_in_6_21, `${ movingPath }/moving-in.06-21.png`],
    [IconType.Live_in_6_22, `${ movingPath }/moving-in.06-22.png`],
    [IconType.Live_in_6_23, `${ movingPath }/moving-in.06-23.png`],
    [IconType.Live_in_6_24, `${ movingPath }/moving-in.06-24.png`],
    [IconType.Live_in_6_25, `${ movingPath }/moving-in.06-25.png`],
    [IconType.Live_in_6_26, `${ movingPath }/moving-in.06-26.png`],
    [IconType.Live_in_6_27, `${ movingPath }/moving-in.06-27.png`],
    [IconType.Live_in_6_28, `${ movingPath }/moving-in.06-28.png`],
    [IconType.Live_in_6_29, `${ movingPath }/moving-in.06-29.png`],
    [IconType.Live_in_6_30, `${ movingPath }/moving-in.06-30.png`],
    [IconType.Live_in_6_31, `${ movingPath }/moving-in.06-31.png`],
    [IconType.Live_in_6_32, `${ movingPath }/moving-in.06-32.png`],
    [IconType.Live_in_6_33, `${ movingPath }/moving-in.06-33.png`],
    [IconType.Live_in_6_34, `${ movingPath }/moving-in.06-34.png`],
    [IconType.Live_in_6_35, `${ movingPath }/moving-in.06-35.png`],
    [IconType.Live_in_7_0, `${ movingPath }/moving-in.07-00.png`],
    [IconType.Live_in_7_1, `${ movingPath }/moving-in.07-01.png`],
    [IconType.Live_in_7_2, `${ movingPath }/moving-in.07-02.png`],
    [IconType.Live_in_7_3, `${ movingPath }/moving-in.07-03.png`],
    [IconType.Live_in_7_4, `${ movingPath }/moving-in.07-04.png`],
    [IconType.Live_in_7_5, `${ movingPath }/moving-in.07-05.png`],
    [IconType.Live_in_7_6, `${ movingPath }/moving-in.07-06.png`],
    [IconType.Live_in_7_7, `${ movingPath }/moving-in.07-07.png`],
    [IconType.Live_in_7_8, `${ movingPath }/moving-in.07-08.png`],
    [IconType.Live_in_7_9, `${ movingPath }/moving-in.07-09.png`],
    [IconType.Live_in_7_10, `${ movingPath }/moving-in.07-10.png`],
    [IconType.Live_in_7_11, `${ movingPath }/moving-in.07-11.png`],
    [IconType.Live_in_7_12, `${ movingPath }/moving-in.07-12.png`],
    [IconType.Live_in_7_13, `${ movingPath }/moving-in.07-13.png`],
    [IconType.Live_in_7_14, `${ movingPath }/moving-in.07-14.png`],
    [IconType.Live_in_7_15, `${ movingPath }/moving-in.07-15.png`],
    [IconType.Live_in_7_16, `${ movingPath }/moving-in.07-16.png`],
    [IconType.Live_in_7_17, `${ movingPath }/moving-in.07-17.png`],
    [IconType.Live_in_7_18, `${ movingPath }/moving-in.07-18.png`],
    [IconType.Live_in_7_19, `${ movingPath }/moving-in.07-19.png`],
    [IconType.Live_in_7_20, `${ movingPath }/moving-in.07-20.png`],
    [IconType.Live_in_7_21, `${ movingPath }/moving-in.07-21.png`],
    [IconType.Live_in_7_22, `${ movingPath }/moving-in.07-22.png`],
    [IconType.Live_in_7_23, `${ movingPath }/moving-in.07-23.png`],
    [IconType.Live_in_7_24, `${ movingPath }/moving-in.07-24.png`],
    [IconType.Live_in_7_25, `${ movingPath }/moving-in.07-25.png`],
    [IconType.Live_in_7_26, `${ movingPath }/moving-in.07-26.png`],
    [IconType.Live_in_7_27, `${ movingPath }/moving-in.07-27.png`],
    [IconType.Live_in_7_28, `${ movingPath }/moving-in.07-28.png`],
    [IconType.Live_in_7_29, `${ movingPath }/moving-in.07-29.png`],
    [IconType.Live_in_7_30, `${ movingPath }/moving-in.07-30.png`],
    [IconType.Live_in_7_31, `${ movingPath }/moving-in.07-31.png`],
    [IconType.Live_in_7_32, `${ movingPath }/moving-in.07-32.png`],
    [IconType.Live_in_7_33, `${ movingPath }/moving-in.07-33.png`],
    [IconType.Live_in_7_34, `${ movingPath }/moving-in.07-34.png`],
    [IconType.Live_in_7_35, `${ movingPath }/moving-in.07-35.png`],
    [IconType.Live_in_8_0, `${ movingPath }/moving-in.08-00.png`],
    [IconType.Live_in_8_1, `${ movingPath }/moving-in.08-01.png`],
    [IconType.Live_in_8_2, `${ movingPath }/moving-in.08-02.png`],
    [IconType.Live_in_8_3, `${ movingPath }/moving-in.08-03.png`],
    [IconType.Live_in_8_4, `${ movingPath }/moving-in.08-04.png`],
    [IconType.Live_in_8_5, `${ movingPath }/moving-in.08-05.png`],
    [IconType.Live_in_8_6, `${ movingPath }/moving-in.08-06.png`],
    [IconType.Live_in_8_7, `${ movingPath }/moving-in.08-07.png`],
    [IconType.Live_in_8_8, `${ movingPath }/moving-in.08-08.png`],
    [IconType.Live_in_8_9, `${ movingPath }/moving-in.08-09.png`],
    [IconType.Live_in_8_10, `${ movingPath }/moving-in.08-10.png`],
    [IconType.Live_in_8_11, `${ movingPath }/moving-in.08-11.png`],
    [IconType.Live_in_8_12, `${ movingPath }/moving-in.08-12.png`],
    [IconType.Live_in_8_13, `${ movingPath }/moving-in.08-13.png`],
    [IconType.Live_in_8_14, `${ movingPath }/moving-in.08-14.png`],
    [IconType.Live_in_8_15, `${ movingPath }/moving-in.08-15.png`],
    [IconType.Live_in_8_16, `${ movingPath }/moving-in.08-16.png`],
    [IconType.Live_in_8_17, `${ movingPath }/moving-in.08-17.png`],
    [IconType.Live_in_8_18, `${ movingPath }/moving-in.08-18.png`],
    [IconType.Live_in_8_19, `${ movingPath }/moving-in.08-19.png`],
    [IconType.Live_in_8_20, `${ movingPath }/moving-in.08-20.png`],
    [IconType.Live_in_8_21, `${ movingPath }/moving-in.08-21.png`],
    [IconType.Live_in_8_22, `${ movingPath }/moving-in.08-22.png`],
    [IconType.Live_in_8_23, `${ movingPath }/moving-in.08-23.png`],
    [IconType.Live_in_8_24, `${ movingPath }/moving-in.08-24.png`],
    [IconType.Live_in_8_25, `${ movingPath }/moving-in.08-25.png`],
    [IconType.Live_in_8_26, `${ movingPath }/moving-in.08-26.png`],
    [IconType.Live_in_8_27, `${ movingPath }/moving-in.08-27.png`],
    [IconType.Live_in_8_28, `${ movingPath }/moving-in.08-28.png`],
    [IconType.Live_in_8_29, `${ movingPath }/moving-in.08-29.png`],
    [IconType.Live_in_8_30, `${ movingPath }/moving-in.08-30.png`],
    [IconType.Live_in_8_31, `${ movingPath }/moving-in.08-31.png`],
    [IconType.Live_in_8_32, `${ movingPath }/moving-in.08-32.png`],
    [IconType.Live_in_8_33, `${ movingPath }/moving-in.08-33.png`],
    [IconType.Live_in_8_34, `${ movingPath }/moving-in.08-34.png`],
    [IconType.Live_in_8_35, `${ movingPath }/moving-in.08-35.png`],
    [IconType.Live_in_9_0, `${ movingPath }/moving-in.09-00.png`],
    [IconType.Live_in_9_1, `${ movingPath }/moving-in.09-01.png`],
    [IconType.Live_in_9_2, `${ movingPath }/moving-in.09-02.png`],
    [IconType.Live_in_9_3, `${ movingPath }/moving-in.09-03.png`],
    [IconType.Live_in_9_4, `${ movingPath }/moving-in.09-04.png`],
    [IconType.Live_in_9_5, `${ movingPath }/moving-in.09-05.png`],
    [IconType.Live_in_9_6, `${ movingPath }/moving-in.09-06.png`],
    [IconType.Live_in_9_7, `${ movingPath }/moving-in.09-07.png`],
    [IconType.Live_in_9_8, `${ movingPath }/moving-in.09-08.png`],
    [IconType.Live_in_9_9, `${ movingPath }/moving-in.09-09.png`],
    [IconType.Live_in_9_10, `${ movingPath }/moving-in.09-10.png`],
    [IconType.Live_in_9_11, `${ movingPath }/moving-in.09-11.png`],
    [IconType.Live_in_9_12, `${ movingPath }/moving-in.09-12.png`],
    [IconType.Live_in_9_13, `${ movingPath }/moving-in.09-13.png`],
    [IconType.Live_in_9_14, `${ movingPath }/moving-in.09-14.png`],
    [IconType.Live_in_9_15, `${ movingPath }/moving-in.09-15.png`],
    [IconType.Live_in_9_16, `${ movingPath }/moving-in.09-16.png`],
    [IconType.Live_in_9_17, `${ movingPath }/moving-in.09-17.png`],
    [IconType.Live_in_9_18, `${ movingPath }/moving-in.09-18.png`],
    [IconType.Live_in_9_19, `${ movingPath }/moving-in.09-19.png`],
    [IconType.Live_in_9_20, `${ movingPath }/moving-in.09-20.png`],
    [IconType.Live_in_9_21, `${ movingPath }/moving-in.09-21.png`],
    [IconType.Live_in_9_22, `${ movingPath }/moving-in.09-22.png`],
    [IconType.Live_in_9_23, `${ movingPath }/moving-in.09-23.png`],
    [IconType.Live_in_9_24, `${ movingPath }/moving-in.09-24.png`],
    [IconType.Live_in_9_25, `${ movingPath }/moving-in.09-25.png`],
    [IconType.Live_in_9_26, `${ movingPath }/moving-in.09-26.png`],
    [IconType.Live_in_9_27, `${ movingPath }/moving-in.09-27.png`],
    [IconType.Live_in_9_28, `${ movingPath }/moving-in.09-28.png`],
    [IconType.Live_in_9_29, `${ movingPath }/moving-in.09-29.png`],
    [IconType.Live_in_9_30, `${ movingPath }/moving-in.09-30.png`],
    [IconType.Live_in_9_31, `${ movingPath }/moving-in.09-31.png`],
    [IconType.Live_in_9_32, `${ movingPath }/moving-in.09-32.png`],
    [IconType.Live_in_9_33, `${ movingPath }/moving-in.09-33.png`],
    [IconType.Live_in_9_34, `${ movingPath }/moving-in.09-34.png`],
    [IconType.Live_in_9_35, `${ movingPath }/moving-in.09-35.png`],
    [IconType.Live_in_10_0, `${ movingPath }/moving-in.10-00.png`],
    [IconType.Live_in_10_1, `${ movingPath }/moving-in.10-01.png`],
    [IconType.Live_in_10_2, `${ movingPath }/moving-in.10-02.png`],
    [IconType.Live_in_10_3, `${ movingPath }/moving-in.10-03.png`],
    [IconType.Live_in_10_4, `${ movingPath }/moving-in.10-04.png`],
    [IconType.Live_in_10_5, `${ movingPath }/moving-in.10-05.png`],
    [IconType.Live_in_10_6, `${ movingPath }/moving-in.10-06.png`],
    [IconType.Live_in_10_7, `${ movingPath }/moving-in.10-07.png`],
    [IconType.Live_in_10_8, `${ movingPath }/moving-in.10-08.png`],
    [IconType.Live_in_10_9, `${ movingPath }/moving-in.10-09.png`],
    [IconType.Live_in_10_10, `${ movingPath }/moving-in.10-10.png`],
    [IconType.Live_in_10_11, `${ movingPath }/moving-in.10-11.png`],
    [IconType.Live_in_10_12, `${ movingPath }/moving-in.10-12.png`],
    [IconType.Live_in_10_13, `${ movingPath }/moving-in.10-13.png`],
    [IconType.Live_in_10_14, `${ movingPath }/moving-in.10-14.png`],
    [IconType.Live_in_10_15, `${ movingPath }/moving-in.10-15.png`],
    [IconType.Live_in_10_16, `${ movingPath }/moving-in.10-16.png`],
    [IconType.Live_in_10_17, `${ movingPath }/moving-in.10-17.png`],
    [IconType.Live_in_10_18, `${ movingPath }/moving-in.10-18.png`],
    [IconType.Live_in_10_19, `${ movingPath }/moving-in.10-19.png`],
    [IconType.Live_in_10_20, `${ movingPath }/moving-in.10-20.png`],
    [IconType.Live_in_10_21, `${ movingPath }/moving-in.10-21.png`],
    [IconType.Live_in_10_22, `${ movingPath }/moving-in.10-22.png`],
    [IconType.Live_in_10_23, `${ movingPath }/moving-in.10-23.png`],
    [IconType.Live_in_10_24, `${ movingPath }/moving-in.10-24.png`],
    [IconType.Live_in_10_25, `${ movingPath }/moving-in.10-25.png`],
    [IconType.Live_in_10_26, `${ movingPath }/moving-in.10-26.png`],
    [IconType.Live_in_10_27, `${ movingPath }/moving-in.10-27.png`],
    [IconType.Live_in_10_28, `${ movingPath }/moving-in.10-28.png`],
    [IconType.Live_in_10_29, `${ movingPath }/moving-in.10-29.png`],
    [IconType.Live_in_10_30, `${ movingPath }/moving-in.10-30.png`],
    [IconType.Live_in_10_31, `${ movingPath }/moving-in.10-31.png`],
    [IconType.Live_in_10_32, `${ movingPath }/moving-in.10-32.png`],
    [IconType.Live_in_10_33, `${ movingPath }/moving-in.10-33.png`],
    [IconType.Live_in_10_34, `${ movingPath }/moving-in.10-34.png`],
    [IconType.Live_in_10_35, `${ movingPath }/moving-in.10-35.png`],
    [IconType.Live_in_11_0, `${ movingPath }/moving-in.11-00.png`],
    [IconType.Live_in_11_1, `${ movingPath }/moving-in.11-01.png`],
    [IconType.Live_in_11_2, `${ movingPath }/moving-in.11-02.png`],
    [IconType.Live_in_11_3, `${ movingPath }/moving-in.11-03.png`],
    [IconType.Live_in_11_4, `${ movingPath }/moving-in.11-04.png`],
    [IconType.Live_in_11_5, `${ movingPath }/moving-in.11-05.png`],
    [IconType.Live_in_11_6, `${ movingPath }/moving-in.11-06.png`],
    [IconType.Live_in_11_7, `${ movingPath }/moving-in.11-07.png`],
    [IconType.Live_in_11_8, `${ movingPath }/moving-in.11-08.png`],
    [IconType.Live_in_11_9, `${ movingPath }/moving-in.11-09.png`],
    [IconType.Live_in_11_10, `${ movingPath }/moving-in.11-10.png`],
    [IconType.Live_in_11_11, `${ movingPath }/moving-in.11-11.png`],
    [IconType.Live_in_11_12, `${ movingPath }/moving-in.11-12.png`],
    [IconType.Live_in_11_13, `${ movingPath }/moving-in.11-13.png`],
    [IconType.Live_in_11_14, `${ movingPath }/moving-in.11-14.png`],
    [IconType.Live_in_11_15, `${ movingPath }/moving-in.11-15.png`],
    [IconType.Live_in_11_16, `${ movingPath }/moving-in.11-16.png`],
    [IconType.Live_in_11_17, `${ movingPath }/moving-in.11-17.png`],
    [IconType.Live_in_11_18, `${ movingPath }/moving-in.11-18.png`],
    [IconType.Live_in_11_19, `${ movingPath }/moving-in.11-19.png`],
    [IconType.Live_in_11_20, `${ movingPath }/moving-in.11-20.png`],
    [IconType.Live_in_11_21, `${ movingPath }/moving-in.11-21.png`],
    [IconType.Live_in_11_22, `${ movingPath }/moving-in.11-22.png`],
    [IconType.Live_in_11_23, `${ movingPath }/moving-in.11-23.png`],
    [IconType.Live_in_11_24, `${ movingPath }/moving-in.11-24.png`],
    [IconType.Live_in_11_25, `${ movingPath }/moving-in.11-25.png`],
    [IconType.Live_in_11_26, `${ movingPath }/moving-in.11-26.png`],
    [IconType.Live_in_11_27, `${ movingPath }/moving-in.11-27.png`],
    [IconType.Live_in_11_28, `${ movingPath }/moving-in.11-28.png`],
    [IconType.Live_in_11_29, `${ movingPath }/moving-in.11-29.png`],
    [IconType.Live_in_11_30, `${ movingPath }/moving-in.11-30.png`],
    [IconType.Live_in_11_31, `${ movingPath }/moving-in.11-31.png`],
    [IconType.Live_in_11_32, `${ movingPath }/moving-in.11-32.png`],
    [IconType.Live_in_11_33, `${ movingPath }/moving-in.11-33.png`],
    [IconType.Live_in_11_34, `${ movingPath }/moving-in.11-34.png`],
    [IconType.Live_in_11_35, `${ movingPath }/moving-in.11-35.png`],
    [IconType.Live_in_12_0, `${ movingPath }/moving-in.12-00.png`],
    [IconType.Live_in_12_1, `${ movingPath }/moving-in.12-01.png`],
    [IconType.Live_in_12_2, `${ movingPath }/moving-in.12-02.png`],
    [IconType.Live_in_12_3, `${ movingPath }/moving-in.12-03.png`],
    [IconType.Live_in_12_4, `${ movingPath }/moving-in.12-04.png`],
    [IconType.Live_in_12_5, `${ movingPath }/moving-in.12-05.png`],
    [IconType.Live_in_12_6, `${ movingPath }/moving-in.12-06.png`],
    [IconType.Live_in_12_7, `${ movingPath }/moving-in.12-07.png`],
    [IconType.Live_in_12_8, `${ movingPath }/moving-in.12-08.png`],
    [IconType.Live_in_12_9, `${ movingPath }/moving-in.12-09.png`],
    [IconType.Live_in_12_10, `${ movingPath }/moving-in.12-10.png`],
    [IconType.Live_in_12_11, `${ movingPath }/moving-in.12-11.png`],
    [IconType.Live_in_12_12, `${ movingPath }/moving-in.12-12.png`],
    [IconType.Live_in_12_13, `${ movingPath }/moving-in.12-13.png`],
    [IconType.Live_in_12_14, `${ movingPath }/moving-in.12-14.png`],
    [IconType.Live_in_12_15, `${ movingPath }/moving-in.12-15.png`],
    [IconType.Live_in_12_16, `${ movingPath }/moving-in.12-16.png`],
    [IconType.Live_in_12_17, `${ movingPath }/moving-in.12-17.png`],
    [IconType.Live_in_12_18, `${ movingPath }/moving-in.12-18.png`],
    [IconType.Live_in_12_19, `${ movingPath }/moving-in.12-19.png`],
    [IconType.Live_in_12_20, `${ movingPath }/moving-in.12-20.png`],
    [IconType.Live_in_12_21, `${ movingPath }/moving-in.12-21.png`],
    [IconType.Live_in_12_22, `${ movingPath }/moving-in.12-22.png`],
    [IconType.Live_in_12_23, `${ movingPath }/moving-in.12-23.png`],
    [IconType.Live_in_12_24, `${ movingPath }/moving-in.12-24.png`],
    [IconType.Live_in_12_25, `${ movingPath }/moving-in.12-25.png`],
    [IconType.Live_in_12_26, `${ movingPath }/moving-in.12-26.png`],
    [IconType.Live_in_12_27, `${ movingPath }/moving-in.12-27.png`],
    [IconType.Live_in_12_28, `${ movingPath }/moving-in.12-28.png`],
    [IconType.Live_in_12_29, `${ movingPath }/moving-in.12-29.png`],
    [IconType.Live_in_12_30, `${ movingPath }/moving-in.12-30.png`],
    [IconType.Live_in_12_31, `${ movingPath }/moving-in.12-31.png`],
    [IconType.Live_in_12_32, `${ movingPath }/moving-in.12-32.png`],
    [IconType.Live_in_12_33, `${ movingPath }/moving-in.12-33.png`],
    [IconType.Live_in_12_34, `${ movingPath }/moving-in.12-34.png`],
    [IconType.Live_in_12_35, `${ movingPath }/moving-in.12-35.png`],
    [IconType.Live_in_13_0, `${ movingPath }/moving-in.13-00.png`],
    [IconType.Live_in_13_1, `${ movingPath }/moving-in.13-01.png`],
    [IconType.Live_in_13_2, `${ movingPath }/moving-in.13-02.png`],
    [IconType.Live_in_13_3, `${ movingPath }/moving-in.13-03.png`],
    [IconType.Live_in_13_4, `${ movingPath }/moving-in.13-04.png`],
    [IconType.Live_in_13_5, `${ movingPath }/moving-in.13-05.png`],
    [IconType.Live_in_13_6, `${ movingPath }/moving-in.13-06.png`],
    [IconType.Live_in_13_7, `${ movingPath }/moving-in.13-07.png`],
    [IconType.Live_in_13_8, `${ movingPath }/moving-in.13-08.png`],
    [IconType.Live_in_13_9, `${ movingPath }/moving-in.13-09.png`],
    [IconType.Live_in_13_10, `${ movingPath }/moving-in.13-10.png`],
    [IconType.Live_in_13_11, `${ movingPath }/moving-in.13-11.png`],
    [IconType.Live_in_13_12, `${ movingPath }/moving-in.13-12.png`],
    [IconType.Live_in_13_13, `${ movingPath }/moving-in.13-13.png`],
    [IconType.Live_in_13_14, `${ movingPath }/moving-in.13-14.png`],
    [IconType.Live_in_13_15, `${ movingPath }/moving-in.13-15.png`],
    [IconType.Live_in_13_16, `${ movingPath }/moving-in.13-16.png`],
    [IconType.Live_in_13_17, `${ movingPath }/moving-in.13-17.png`],
    [IconType.Live_in_13_18, `${ movingPath }/moving-in.13-18.png`],
    [IconType.Live_in_13_19, `${ movingPath }/moving-in.13-19.png`],
    [IconType.Live_in_13_20, `${ movingPath }/moving-in.13-20.png`],
    [IconType.Live_in_13_21, `${ movingPath }/moving-in.13-21.png`],
    [IconType.Live_in_13_22, `${ movingPath }/moving-in.13-22.png`],
    [IconType.Live_in_13_23, `${ movingPath }/moving-in.13-23.png`],
    [IconType.Live_in_13_24, `${ movingPath }/moving-in.13-24.png`],
    [IconType.Live_in_13_25, `${ movingPath }/moving-in.13-25.png`],
    [IconType.Live_in_13_26, `${ movingPath }/moving-in.13-26.png`],
    [IconType.Live_in_13_27, `${ movingPath }/moving-in.13-27.png`],
    [IconType.Live_in_13_28, `${ movingPath }/moving-in.13-28.png`],
    [IconType.Live_in_13_29, `${ movingPath }/moving-in.13-29.png`],
    [IconType.Live_in_13_30, `${ movingPath }/moving-in.13-30.png`],
    [IconType.Live_in_13_31, `${ movingPath }/moving-in.13-31.png`],
    [IconType.Live_in_13_32, `${ movingPath }/moving-in.13-32.png`],
    [IconType.Live_in_13_33, `${ movingPath }/moving-in.13-33.png`],
    [IconType.Live_in_13_34, `${ movingPath }/moving-in.13-34.png`],
    [IconType.Live_in_13_35, `${ movingPath }/moving-in.13-35.png`],
    [IconType.Live_in_14_0, `${ movingPath }/moving-in.14-00.png`],
    [IconType.Live_in_14_1, `${ movingPath }/moving-in.14-01.png`],
    [IconType.Live_in_14_2, `${ movingPath }/moving-in.14-02.png`],
    [IconType.Live_in_14_3, `${ movingPath }/moving-in.14-03.png`],
    [IconType.Live_in_14_4, `${ movingPath }/moving-in.14-04.png`],
    [IconType.Live_in_14_5, `${ movingPath }/moving-in.14-05.png`],
    [IconType.Live_in_14_6, `${ movingPath }/moving-in.14-06.png`],
    [IconType.Live_in_14_7, `${ movingPath }/moving-in.14-07.png`],
    [IconType.Live_in_14_8, `${ movingPath }/moving-in.14-08.png`],
    [IconType.Live_in_14_9, `${ movingPath }/moving-in.14-09.png`],
    [IconType.Live_in_14_10, `${ movingPath }/moving-in.14-10.png`],
    [IconType.Live_in_14_11, `${ movingPath }/moving-in.14-11.png`],
    [IconType.Live_in_14_12, `${ movingPath }/moving-in.14-12.png`],
    [IconType.Live_in_14_13, `${ movingPath }/moving-in.14-13.png`],
    [IconType.Live_in_14_14, `${ movingPath }/moving-in.14-14.png`],
    [IconType.Live_in_14_15, `${ movingPath }/moving-in.14-15.png`],
    [IconType.Live_in_14_16, `${ movingPath }/moving-in.14-16.png`],
    [IconType.Live_in_14_17, `${ movingPath }/moving-in.14-17.png`],
    [IconType.Live_in_14_18, `${ movingPath }/moving-in.14-18.png`],
    [IconType.Live_in_14_19, `${ movingPath }/moving-in.14-19.png`],
    [IconType.Live_in_14_20, `${ movingPath }/moving-in.14-20.png`],
    [IconType.Live_in_14_21, `${ movingPath }/moving-in.14-21.png`],
    [IconType.Live_in_14_22, `${ movingPath }/moving-in.14-22.png`],
    [IconType.Live_in_14_23, `${ movingPath }/moving-in.14-23.png`],
    [IconType.Live_in_14_24, `${ movingPath }/moving-in.14-24.png`],
    [IconType.Live_in_14_25, `${ movingPath }/moving-in.14-25.png`],
    [IconType.Live_in_14_26, `${ movingPath }/moving-in.14-26.png`],
    [IconType.Live_in_14_27, `${ movingPath }/moving-in.14-27.png`],
    [IconType.Live_in_14_28, `${ movingPath }/moving-in.14-28.png`],
    [IconType.Live_in_14_29, `${ movingPath }/moving-in.14-29.png`],
    [IconType.Live_in_14_30, `${ movingPath }/moving-in.14-30.png`],
    [IconType.Live_in_14_31, `${ movingPath }/moving-in.14-31.png`],
    [IconType.Live_in_14_32, `${ movingPath }/moving-in.14-32.png`],
    [IconType.Live_in_14_33, `${ movingPath }/moving-in.14-33.png`],
    [IconType.Live_in_14_34, `${ movingPath }/moving-in.14-34.png`],
    [IconType.Live_in_14_35, `${ movingPath }/moving-in.14-35.png`],
    [IconType.Live_in_15_0, `${ movingPath }/moving-in.15-00.png`],
    [IconType.Live_in_15_1, `${ movingPath }/moving-in.15-01.png`],
    [IconType.Live_in_15_2, `${ movingPath }/moving-in.15-02.png`],
    [IconType.Live_in_15_3, `${ movingPath }/moving-in.15-03.png`],
    [IconType.Live_in_15_4, `${ movingPath }/moving-in.15-04.png`],
    [IconType.Live_in_15_5, `${ movingPath }/moving-in.15-05.png`],
    [IconType.Live_in_15_6, `${ movingPath }/moving-in.15-06.png`],
    [IconType.Live_in_15_7, `${ movingPath }/moving-in.15-07.png`],
    [IconType.Live_in_15_8, `${ movingPath }/moving-in.15-08.png`],
    [IconType.Live_in_15_9, `${ movingPath }/moving-in.15-09.png`],
    [IconType.Live_in_15_10, `${ movingPath }/moving-in.15-10.png`],
    [IconType.Live_in_15_11, `${ movingPath }/moving-in.15-11.png`],
    [IconType.Live_in_15_12, `${ movingPath }/moving-in.15-12.png`],
    [IconType.Live_in_15_13, `${ movingPath }/moving-in.15-13.png`],
    [IconType.Live_in_15_14, `${ movingPath }/moving-in.15-14.png`],
    [IconType.Live_in_15_15, `${ movingPath }/moving-in.15-15.png`],
    [IconType.Live_in_15_16, `${ movingPath }/moving-in.15-16.png`],
    [IconType.Live_in_15_17, `${ movingPath }/moving-in.15-17.png`],
    [IconType.Live_in_15_18, `${ movingPath }/moving-in.15-18.png`],
    [IconType.Live_in_15_19, `${ movingPath }/moving-in.15-19.png`],
    [IconType.Live_in_15_20, `${ movingPath }/moving-in.15-20.png`],
    [IconType.Live_in_15_21, `${ movingPath }/moving-in.15-21.png`],
    [IconType.Live_in_15_22, `${ movingPath }/moving-in.15-22.png`],
    [IconType.Live_in_15_23, `${ movingPath }/moving-in.15-23.png`],
    [IconType.Live_in_15_24, `${ movingPath }/moving-in.15-24.png`],
    [IconType.Live_in_15_25, `${ movingPath }/moving-in.15-25.png`],
    [IconType.Live_in_15_26, `${ movingPath }/moving-in.15-26.png`],
    [IconType.Live_in_15_27, `${ movingPath }/moving-in.15-27.png`],
    [IconType.Live_in_15_28, `${ movingPath }/moving-in.15-28.png`],
    [IconType.Live_in_15_29, `${ movingPath }/moving-in.15-29.png`],
    [IconType.Live_in_15_30, `${ movingPath }/moving-in.15-30.png`],
    [IconType.Live_in_15_31, `${ movingPath }/moving-in.15-31.png`],
    [IconType.Live_in_15_32, `${ movingPath }/moving-in.15-32.png`],
    [IconType.Live_in_15_33, `${ movingPath }/moving-in.15-33.png`],
    [IconType.Live_in_15_34, `${ movingPath }/moving-in.15-34.png`],
    [IconType.Live_in_15_35, `${ movingPath }/moving-in.15-35.png`],
    [IconType.Live_in_16_0, `${ movingPath }/moving-in.16-00.png`],
    [IconType.Live_in_16_1, `${ movingPath }/moving-in.16-01.png`],
    [IconType.Live_in_16_2, `${ movingPath }/moving-in.16-02.png`],
    [IconType.Live_in_16_3, `${ movingPath }/moving-in.16-03.png`],
    [IconType.Live_in_16_4, `${ movingPath }/moving-in.16-04.png`],
    [IconType.Live_in_16_5, `${ movingPath }/moving-in.16-05.png`],
    [IconType.Live_in_16_6, `${ movingPath }/moving-in.16-06.png`],
    [IconType.Live_in_16_7, `${ movingPath }/moving-in.16-07.png`],
    [IconType.Live_in_16_8, `${ movingPath }/moving-in.16-08.png`],
    [IconType.Live_in_16_9, `${ movingPath }/moving-in.16-09.png`],
    [IconType.Live_in_16_10, `${ movingPath }/moving-in.16-10.png`],
    [IconType.Live_in_16_11, `${ movingPath }/moving-in.16-11.png`],
    [IconType.Live_in_16_12, `${ movingPath }/moving-in.16-12.png`],
    [IconType.Live_in_16_13, `${ movingPath }/moving-in.16-13.png`],
    [IconType.Live_in_16_14, `${ movingPath }/moving-in.16-14.png`],
    [IconType.Live_in_16_15, `${ movingPath }/moving-in.16-15.png`],
    [IconType.Live_in_16_16, `${ movingPath }/moving-in.16-16.png`],
    [IconType.Live_in_16_17, `${ movingPath }/moving-in.16-17.png`],
    [IconType.Live_in_16_18, `${ movingPath }/moving-in.16-18.png`],
    [IconType.Live_in_16_19, `${ movingPath }/moving-in.16-19.png`],
    [IconType.Live_in_16_20, `${ movingPath }/moving-in.16-20.png`],
    [IconType.Live_in_16_21, `${ movingPath }/moving-in.16-21.png`],
    [IconType.Live_in_16_22, `${ movingPath }/moving-in.16-22.png`],
    [IconType.Live_in_16_23, `${ movingPath }/moving-in.16-23.png`],
    [IconType.Live_in_16_24, `${ movingPath }/moving-in.16-24.png`],
    [IconType.Live_in_16_25, `${ movingPath }/moving-in.16-25.png`],
    [IconType.Live_in_16_26, `${ movingPath }/moving-in.16-26.png`],
    [IconType.Live_in_16_27, `${ movingPath }/moving-in.16-27.png`],
    [IconType.Live_in_16_28, `${ movingPath }/moving-in.16-28.png`],
    [IconType.Live_in_16_29, `${ movingPath }/moving-in.16-29.png`],
    [IconType.Live_in_16_30, `${ movingPath }/moving-in.16-30.png`],
    [IconType.Live_in_16_31, `${ movingPath }/moving-in.16-31.png`],
    [IconType.Live_in_16_32, `${ movingPath }/moving-in.16-32.png`],
    [IconType.Live_in_16_33, `${ movingPath }/moving-in.16-33.png`],
    [IconType.Live_in_16_34, `${ movingPath }/moving-in.16-34.png`],
    [IconType.Live_in_16_35, `${ movingPath }/moving-in.16-35.png`],
    [IconType.Live_in_17_0, `${ movingPath }/moving-in.17-00.png`],
    [IconType.Live_in_17_1, `${ movingPath }/moving-in.17-01.png`],
    [IconType.Live_in_17_2, `${ movingPath }/moving-in.17-02.png`],
    [IconType.Live_in_17_3, `${ movingPath }/moving-in.17-03.png`],
    [IconType.Live_in_17_4, `${ movingPath }/moving-in.17-04.png`],
    [IconType.Live_in_17_5, `${ movingPath }/moving-in.17-05.png`],
    [IconType.Live_in_17_6, `${ movingPath }/moving-in.17-06.png`],
    [IconType.Live_in_17_7, `${ movingPath }/moving-in.17-07.png`],
    [IconType.Live_in_17_8, `${ movingPath }/moving-in.17-08.png`],
    [IconType.Live_in_17_9, `${ movingPath }/moving-in.17-09.png`],
    [IconType.Live_in_17_10, `${ movingPath }/moving-in.17-10.png`],
    [IconType.Live_in_17_11, `${ movingPath }/moving-in.17-11.png`],
    [IconType.Live_in_17_12, `${ movingPath }/moving-in.17-12.png`],
    [IconType.Live_in_17_13, `${ movingPath }/moving-in.17-13.png`],
    [IconType.Live_in_17_14, `${ movingPath }/moving-in.17-14.png`],
    [IconType.Live_in_17_15, `${ movingPath }/moving-in.17-15.png`],
    [IconType.Live_in_17_16, `${ movingPath }/moving-in.17-16.png`],
    [IconType.Live_in_17_17, `${ movingPath }/moving-in.17-17.png`],
    [IconType.Live_in_17_18, `${ movingPath }/moving-in.17-18.png`],
    [IconType.Live_in_17_19, `${ movingPath }/moving-in.17-19.png`],
    [IconType.Live_in_17_20, `${ movingPath }/moving-in.17-20.png`],
    [IconType.Live_in_17_21, `${ movingPath }/moving-in.17-21.png`],
    [IconType.Live_in_17_22, `${ movingPath }/moving-in.17-22.png`],
    [IconType.Live_in_17_23, `${ movingPath }/moving-in.17-23.png`],
    [IconType.Live_in_17_24, `${ movingPath }/moving-in.17-24.png`],
    [IconType.Live_in_17_25, `${ movingPath }/moving-in.17-25.png`],
    [IconType.Live_in_17_26, `${ movingPath }/moving-in.17-26.png`],
    [IconType.Live_in_17_27, `${ movingPath }/moving-in.17-27.png`],
    [IconType.Live_in_17_28, `${ movingPath }/moving-in.17-28.png`],
    [IconType.Live_in_17_29, `${ movingPath }/moving-in.17-29.png`],
    [IconType.Live_in_17_30, `${ movingPath }/moving-in.17-30.png`],
    [IconType.Live_in_17_31, `${ movingPath }/moving-in.17-31.png`],
    [IconType.Live_in_17_32, `${ movingPath }/moving-in.17-32.png`],
    [IconType.Live_in_17_33, `${ movingPath }/moving-in.17-33.png`],
    [IconType.Live_in_17_34, `${ movingPath }/moving-in.17-34.png`],
    [IconType.Live_in_17_35, `${ movingPath }/moving-in.17-35.png`],
    [IconType.Live_in_18_0, `${ movingPath }/moving-in.18-00.png`],
    [IconType.Live_in_18_1, `${ movingPath }/moving-in.18-01.png`],
    [IconType.Live_in_18_2, `${ movingPath }/moving-in.18-02.png`],
    [IconType.Live_in_18_3, `${ movingPath }/moving-in.18-03.png`],
    [IconType.Live_in_18_4, `${ movingPath }/moving-in.18-04.png`],
    [IconType.Live_in_18_5, `${ movingPath }/moving-in.18-05.png`],
    [IconType.Live_in_18_6, `${ movingPath }/moving-in.18-06.png`],
    [IconType.Live_in_18_7, `${ movingPath }/moving-in.18-07.png`],
    [IconType.Live_in_18_8, `${ movingPath }/moving-in.18-08.png`],
    [IconType.Live_in_18_9, `${ movingPath }/moving-in.18-09.png`],
    [IconType.Live_in_18_10, `${ movingPath }/moving-in.18-10.png`],
    [IconType.Live_in_18_11, `${ movingPath }/moving-in.18-11.png`],
    [IconType.Live_in_18_12, `${ movingPath }/moving-in.18-12.png`],
    [IconType.Live_in_18_13, `${ movingPath }/moving-in.18-13.png`],
    [IconType.Live_in_18_14, `${ movingPath }/moving-in.18-14.png`],
    [IconType.Live_in_18_15, `${ movingPath }/moving-in.18-15.png`],
    [IconType.Live_in_18_16, `${ movingPath }/moving-in.18-16.png`],
    [IconType.Live_in_18_17, `${ movingPath }/moving-in.18-17.png`],
    [IconType.Live_in_18_18, `${ movingPath }/moving-in.18-18.png`],
    [IconType.Live_in_18_19, `${ movingPath }/moving-in.18-19.png`],
    [IconType.Live_in_18_20, `${ movingPath }/moving-in.18-20.png`],
    [IconType.Live_in_18_21, `${ movingPath }/moving-in.18-21.png`],
    [IconType.Live_in_18_22, `${ movingPath }/moving-in.18-22.png`],
    [IconType.Live_in_18_23, `${ movingPath }/moving-in.18-23.png`],
    [IconType.Live_in_18_24, `${ movingPath }/moving-in.18-24.png`],
    [IconType.Live_in_18_25, `${ movingPath }/moving-in.18-25.png`],
    [IconType.Live_in_18_26, `${ movingPath }/moving-in.18-26.png`],
    [IconType.Live_in_18_27, `${ movingPath }/moving-in.18-27.png`],
    [IconType.Live_in_18_28, `${ movingPath }/moving-in.18-28.png`],
    [IconType.Live_in_18_29, `${ movingPath }/moving-in.18-29.png`],
    [IconType.Live_in_18_30, `${ movingPath }/moving-in.18-30.png`],
    [IconType.Live_in_18_31, `${ movingPath }/moving-in.18-31.png`],
    [IconType.Live_in_18_32, `${ movingPath }/moving-in.18-32.png`],
    [IconType.Live_in_18_33, `${ movingPath }/moving-in.18-33.png`],
    [IconType.Live_in_18_34, `${ movingPath }/moving-in.18-34.png`],
    [IconType.Live_in_18_35, `${ movingPath }/moving-in.18-35.png`]
]);

const iconLinks2 = new Map<IconType, string>([
    [IconType.Live_out_0_0, `${ movingPath }/moving-in.00-00.png`],
    [IconType.Live_out_0_1, `${ movingPath }/moving-in.00-01.png`],
    [IconType.Live_out_0_2, `${ movingPath }/moving-in.00-02.png`],
    [IconType.Live_out_0_3, `${ movingPath }/moving-in.00-03.png`],
    [IconType.Live_out_0_4, `${ movingPath }/moving-in.00-04.png`],
    [IconType.Live_out_0_5, `${ movingPath }/moving-in.00-05.png`],
    [IconType.Live_out_0_6, `${ movingPath }/moving-in.00-06.png`],
    [IconType.Live_out_0_7, `${ movingPath }/moving-in.00-07.png`],
    [IconType.Live_out_0_8, `${ movingPath }/moving-in.00-08.png`],
    [IconType.Live_out_0_9, `${ movingPath }/moving-in.00-09.png`],
    [IconType.Live_out_0_10, `${ movingPath }/moving-in.00-10.png`],
    [IconType.Live_out_0_11, `${ movingPath }/moving-in.00-11.png`],
    [IconType.Live_out_0_12, `${ movingPath }/moving-in.00-12.png`],
    [IconType.Live_out_0_13, `${ movingPath }/moving-in.00-13.png`],
    [IconType.Live_out_0_14, `${ movingPath }/moving-in.00-14.png`],
    [IconType.Live_out_0_15, `${ movingPath }/moving-in.00-15.png`],
    [IconType.Live_out_0_16, `${ movingPath }/moving-in.00-16.png`],
    [IconType.Live_out_0_17, `${ movingPath }/moving-in.00-17.png`],
    [IconType.Live_out_0_18, `${ movingPath }/moving-in.00-18.png`],
    [IconType.Live_out_0_19, `${ movingPath }/moving-in.00-19.png`],
    [IconType.Live_out_0_20, `${ movingPath }/moving-in.00-20.png`],
    [IconType.Live_out_0_21, `${ movingPath }/moving-in.00-21.png`],
    [IconType.Live_out_0_22, `${ movingPath }/moving-in.00-22.png`],
    [IconType.Live_out_0_23, `${ movingPath }/moving-in.00-23.png`],
    [IconType.Live_out_0_24, `${ movingPath }/moving-in.00-24.png`],
    [IconType.Live_out_0_25, `${ movingPath }/moving-in.00-25.png`],
    [IconType.Live_out_0_26, `${ movingPath }/moving-in.00-26.png`],
    [IconType.Live_out_0_27, `${ movingPath }/moving-in.00-27.png`],
    [IconType.Live_out_0_28, `${ movingPath }/moving-in.00-28.png`],
    [IconType.Live_out_0_29, `${ movingPath }/moving-in.00-29.png`],
    [IconType.Live_out_0_30, `${ movingPath }/moving-in.00-30.png`],
    [IconType.Live_out_0_31, `${ movingPath }/moving-in.00-31.png`],
    [IconType.Live_out_0_32, `${ movingPath }/moving-in.00-32.png`],
    [IconType.Live_out_0_33, `${ movingPath }/moving-in.00-33.png`],
    [IconType.Live_out_0_34, `${ movingPath }/moving-in.00-34.png`],
    [IconType.Live_out_0_35, `${ movingPath }/moving-in.00-35.png`],
    [IconType.Live_out_1_0, `${ movingPath }/moving-in.01-00.png`],
    [IconType.Live_out_1_1, `${ movingPath }/moving-in.01-01.png`],
    [IconType.Live_out_1_2, `${ movingPath }/moving-in.01-02.png`],
    [IconType.Live_out_1_3, `${ movingPath }/moving-in.01-03.png`],
    [IconType.Live_out_1_4, `${ movingPath }/moving-in.01-04.png`],
    [IconType.Live_out_1_5, `${ movingPath }/moving-in.01-05.png`],
    [IconType.Live_out_1_6, `${ movingPath }/moving-in.01-06.png`],
    [IconType.Live_out_1_7, `${ movingPath }/moving-in.01-07.png`],
    [IconType.Live_out_1_8, `${ movingPath }/moving-in.01-08.png`],
    [IconType.Live_out_1_9, `${ movingPath }/moving-in.01-09.png`],
    [IconType.Live_out_1_10, `${ movingPath }/moving-in.01-10.png`],
    [IconType.Live_out_1_11, `${ movingPath }/moving-in.01-11.png`],
    [IconType.Live_out_1_12, `${ movingPath }/moving-in.01-12.png`],
    [IconType.Live_out_1_13, `${ movingPath }/moving-in.01-13.png`],
    [IconType.Live_out_1_14, `${ movingPath }/moving-in.01-14.png`],
    [IconType.Live_out_1_15, `${ movingPath }/moving-in.01-15.png`],
    [IconType.Live_out_1_16, `${ movingPath }/moving-in.01-16.png`],
    [IconType.Live_out_1_17, `${ movingPath }/moving-in.01-17.png`],
    [IconType.Live_out_1_18, `${ movingPath }/moving-in.01-18.png`],
    [IconType.Live_out_1_19, `${ movingPath }/moving-in.01-19.png`],
    [IconType.Live_out_1_20, `${ movingPath }/moving-in.01-20.png`],
    [IconType.Live_out_1_21, `${ movingPath }/moving-in.01-21.png`],
    [IconType.Live_out_1_22, `${ movingPath }/moving-in.01-22.png`],
    [IconType.Live_out_1_23, `${ movingPath }/moving-in.01-23.png`],
    [IconType.Live_out_1_24, `${ movingPath }/moving-in.01-24.png`],
    [IconType.Live_out_1_25, `${ movingPath }/moving-in.01-25.png`],
    [IconType.Live_out_1_26, `${ movingPath }/moving-in.01-26.png`],
    [IconType.Live_out_1_27, `${ movingPath }/moving-in.01-27.png`],
    [IconType.Live_out_1_28, `${ movingPath }/moving-in.01-28.png`],
    [IconType.Live_out_1_29, `${ movingPath }/moving-in.01-29.png`],
    [IconType.Live_out_1_30, `${ movingPath }/moving-in.01-30.png`],
    [IconType.Live_out_1_31, `${ movingPath }/moving-in.01-31.png`],
    [IconType.Live_out_1_32, `${ movingPath }/moving-in.01-32.png`],
    [IconType.Live_out_1_33, `${ movingPath }/moving-in.01-33.png`],
    [IconType.Live_out_1_34, `${ movingPath }/moving-in.01-34.png`],
    [IconType.Live_out_1_35, `${ movingPath }/moving-in.01-35.png`],
    [IconType.Live_out_2_0, `${ movingPath }/moving-in.02-00.png`],
    [IconType.Live_out_2_1, `${ movingPath }/moving-in.02-01.png`],
    [IconType.Live_out_2_2, `${ movingPath }/moving-in.02-02.png`],
    [IconType.Live_out_2_3, `${ movingPath }/moving-in.02-03.png`],
    [IconType.Live_out_2_4, `${ movingPath }/moving-in.02-04.png`],
    [IconType.Live_out_2_5, `${ movingPath }/moving-in.02-05.png`],
    [IconType.Live_out_2_6, `${ movingPath }/moving-in.02-06.png`],
    [IconType.Live_out_2_7, `${ movingPath }/moving-in.02-07.png`],
    [IconType.Live_out_2_8, `${ movingPath }/moving-in.02-08.png`],
    [IconType.Live_out_2_9, `${ movingPath }/moving-in.02-09.png`],
    [IconType.Live_out_2_10, `${ movingPath }/moving-in.02-10.png`],
    [IconType.Live_out_2_11, `${ movingPath }/moving-in.02-11.png`],
    [IconType.Live_out_2_12, `${ movingPath }/moving-in.02-12.png`],
    [IconType.Live_out_2_13, `${ movingPath }/moving-in.02-13.png`],
    [IconType.Live_out_2_14, `${ movingPath }/moving-in.02-14.png`],
    [IconType.Live_out_2_15, `${ movingPath }/moving-in.02-15.png`],
    [IconType.Live_out_2_16, `${ movingPath }/moving-in.02-16.png`],
    [IconType.Live_out_2_17, `${ movingPath }/moving-in.02-17.png`],
    [IconType.Live_out_2_18, `${ movingPath }/moving-in.02-18.png`],
    [IconType.Live_out_2_19, `${ movingPath }/moving-in.02-19.png`],
    [IconType.Live_out_2_20, `${ movingPath }/moving-in.02-20.png`],
    [IconType.Live_out_2_21, `${ movingPath }/moving-in.02-21.png`],
    [IconType.Live_out_2_22, `${ movingPath }/moving-in.02-22.png`],
    [IconType.Live_out_2_23, `${ movingPath }/moving-in.02-23.png`],
    [IconType.Live_out_2_24, `${ movingPath }/moving-in.02-24.png`],
    [IconType.Live_out_2_25, `${ movingPath }/moving-in.02-25.png`],
    [IconType.Live_out_2_26, `${ movingPath }/moving-in.02-26.png`],
    [IconType.Live_out_2_27, `${ movingPath }/moving-in.02-27.png`],
    [IconType.Live_out_2_28, `${ movingPath }/moving-in.02-28.png`],
    [IconType.Live_out_2_29, `${ movingPath }/moving-in.02-29.png`],
    [IconType.Live_out_2_30, `${ movingPath }/moving-in.02-30.png`],
    [IconType.Live_out_2_31, `${ movingPath }/moving-in.02-31.png`],
    [IconType.Live_out_2_32, `${ movingPath }/moving-in.02-32.png`],
    [IconType.Live_out_2_33, `${ movingPath }/moving-in.02-33.png`],
    [IconType.Live_out_2_34, `${ movingPath }/moving-in.02-34.png`],
    [IconType.Live_out_2_35, `${ movingPath }/moving-in.02-35.png`],
    [IconType.Live_out_3_0, `${ movingPath }/moving-in.03-00.png`],
    [IconType.Live_out_3_1, `${ movingPath }/moving-in.03-01.png`],
    [IconType.Live_out_3_2, `${ movingPath }/moving-in.03-02.png`],
    [IconType.Live_out_3_3, `${ movingPath }/moving-in.03-03.png`],
    [IconType.Live_out_3_4, `${ movingPath }/moving-in.03-04.png`],
    [IconType.Live_out_3_5, `${ movingPath }/moving-in.03-05.png`],
    [IconType.Live_out_3_6, `${ movingPath }/moving-in.03-06.png`],
    [IconType.Live_out_3_7, `${ movingPath }/moving-in.03-07.png`],
    [IconType.Live_out_3_8, `${ movingPath }/moving-in.03-08.png`],
    [IconType.Live_out_3_9, `${ movingPath }/moving-in.03-09.png`],
    [IconType.Live_out_3_10, `${ movingPath }/moving-in.03-10.png`],
    [IconType.Live_out_3_11, `${ movingPath }/moving-in.03-11.png`],
    [IconType.Live_out_3_12, `${ movingPath }/moving-in.03-12.png`],
    [IconType.Live_out_3_13, `${ movingPath }/moving-in.03-13.png`],
    [IconType.Live_out_3_14, `${ movingPath }/moving-in.03-14.png`],
    [IconType.Live_out_3_15, `${ movingPath }/moving-in.03-15.png`],
    [IconType.Live_out_3_16, `${ movingPath }/moving-in.03-16.png`],
    [IconType.Live_out_3_17, `${ movingPath }/moving-in.03-17.png`],
    [IconType.Live_out_3_18, `${ movingPath }/moving-in.03-18.png`],
    [IconType.Live_out_3_19, `${ movingPath }/moving-in.03-19.png`],
    [IconType.Live_out_3_20, `${ movingPath }/moving-in.03-20.png`],
    [IconType.Live_out_3_21, `${ movingPath }/moving-in.03-21.png`],
    [IconType.Live_out_3_22, `${ movingPath }/moving-in.03-22.png`],
    [IconType.Live_out_3_23, `${ movingPath }/moving-in.03-23.png`],
    [IconType.Live_out_3_24, `${ movingPath }/moving-in.03-24.png`],
    [IconType.Live_out_3_25, `${ movingPath }/moving-in.03-25.png`],
    [IconType.Live_out_3_26, `${ movingPath }/moving-in.03-26.png`],
    [IconType.Live_out_3_27, `${ movingPath }/moving-in.03-27.png`],
    [IconType.Live_out_3_28, `${ movingPath }/moving-in.03-28.png`],
    [IconType.Live_out_3_29, `${ movingPath }/moving-in.03-29.png`],
    [IconType.Live_out_3_30, `${ movingPath }/moving-in.03-30.png`],
    [IconType.Live_out_3_31, `${ movingPath }/moving-in.03-31.png`],
    [IconType.Live_out_3_32, `${ movingPath }/moving-in.03-32.png`],
    [IconType.Live_out_3_33, `${ movingPath }/moving-in.03-33.png`],
    [IconType.Live_out_3_34, `${ movingPath }/moving-in.03-34.png`],
    [IconType.Live_out_3_35, `${ movingPath }/moving-in.03-35.png`],
    [IconType.Live_out_4_0, `${ movingPath }/moving-in.04-00.png`],
    [IconType.Live_out_4_1, `${ movingPath }/moving-in.04-01.png`],
    [IconType.Live_out_4_2, `${ movingPath }/moving-in.04-02.png`],
    [IconType.Live_out_4_3, `${ movingPath }/moving-in.04-03.png`],
    [IconType.Live_out_4_4, `${ movingPath }/moving-in.04-04.png`],
    [IconType.Live_out_4_5, `${ movingPath }/moving-in.04-05.png`],
    [IconType.Live_out_4_6, `${ movingPath }/moving-in.04-06.png`],
    [IconType.Live_out_4_7, `${ movingPath }/moving-in.04-07.png`],
    [IconType.Live_out_4_8, `${ movingPath }/moving-in.04-08.png`],
    [IconType.Live_out_4_9, `${ movingPath }/moving-in.04-09.png`],
    [IconType.Live_out_4_10, `${ movingPath }/moving-in.04-10.png`],
    [IconType.Live_out_4_11, `${ movingPath }/moving-in.04-11.png`],
    [IconType.Live_out_4_12, `${ movingPath }/moving-in.04-12.png`],
    [IconType.Live_out_4_13, `${ movingPath }/moving-in.04-13.png`],
    [IconType.Live_out_4_14, `${ movingPath }/moving-in.04-14.png`],
    [IconType.Live_out_4_15, `${ movingPath }/moving-in.04-15.png`],
    [IconType.Live_out_4_16, `${ movingPath }/moving-in.04-16.png`],
    [IconType.Live_out_4_17, `${ movingPath }/moving-in.04-17.png`],
    [IconType.Live_out_4_18, `${ movingPath }/moving-in.04-18.png`],
    [IconType.Live_out_4_19, `${ movingPath }/moving-in.04-19.png`],
    [IconType.Live_out_4_20, `${ movingPath }/moving-in.04-20.png`],
    [IconType.Live_out_4_21, `${ movingPath }/moving-in.04-21.png`],
    [IconType.Live_out_4_22, `${ movingPath }/moving-in.04-22.png`],
    [IconType.Live_out_4_23, `${ movingPath }/moving-in.04-23.png`],
    [IconType.Live_out_4_24, `${ movingPath }/moving-in.04-24.png`],
    [IconType.Live_out_4_25, `${ movingPath }/moving-in.04-25.png`],
    [IconType.Live_out_4_26, `${ movingPath }/moving-in.04-26.png`],
    [IconType.Live_out_4_27, `${ movingPath }/moving-in.04-27.png`],
    [IconType.Live_out_4_28, `${ movingPath }/moving-in.04-28.png`],
    [IconType.Live_out_4_29, `${ movingPath }/moving-in.04-29.png`],
    [IconType.Live_out_4_30, `${ movingPath }/moving-in.04-30.png`],
    [IconType.Live_out_4_31, `${ movingPath }/moving-in.04-31.png`],
    [IconType.Live_out_4_32, `${ movingPath }/moving-in.04-32.png`],
    [IconType.Live_out_4_33, `${ movingPath }/moving-in.04-33.png`],
    [IconType.Live_out_4_34, `${ movingPath }/moving-in.04-34.png`],
    [IconType.Live_out_4_35, `${ movingPath }/moving-in.04-35.png`],
    [IconType.Live_out_5_0, `${ movingPath }/moving-in.05-00.png`],
    [IconType.Live_out_5_1, `${ movingPath }/moving-in.05-01.png`],
    [IconType.Live_out_5_2, `${ movingPath }/moving-in.05-02.png`],
    [IconType.Live_out_5_3, `${ movingPath }/moving-in.05-03.png`],
    [IconType.Live_out_5_4, `${ movingPath }/moving-in.05-04.png`],
    [IconType.Live_out_5_5, `${ movingPath }/moving-in.05-05.png`],
    [IconType.Live_out_5_6, `${ movingPath }/moving-in.05-06.png`],
    [IconType.Live_out_5_7, `${ movingPath }/moving-in.05-07.png`],
    [IconType.Live_out_5_8, `${ movingPath }/moving-in.05-08.png`],
    [IconType.Live_out_5_9, `${ movingPath }/moving-in.05-09.png`],
    [IconType.Live_out_5_10, `${ movingPath }/moving-in.05-10.png`],
    [IconType.Live_out_5_11, `${ movingPath }/moving-in.05-11.png`],
    [IconType.Live_out_5_12, `${ movingPath }/moving-in.05-12.png`],
    [IconType.Live_out_5_13, `${ movingPath }/moving-in.05-13.png`],
    [IconType.Live_out_5_14, `${ movingPath }/moving-in.05-14.png`],
    [IconType.Live_out_5_15, `${ movingPath }/moving-in.05-15.png`],
    [IconType.Live_out_5_16, `${ movingPath }/moving-in.05-16.png`],
    [IconType.Live_out_5_17, `${ movingPath }/moving-in.05-17.png`],
    [IconType.Live_out_5_18, `${ movingPath }/moving-in.05-18.png`],
    [IconType.Live_out_5_19, `${ movingPath }/moving-in.05-19.png`],
    [IconType.Live_out_5_20, `${ movingPath }/moving-in.05-20.png`],
    [IconType.Live_out_5_21, `${ movingPath }/moving-in.05-21.png`],
    [IconType.Live_out_5_22, `${ movingPath }/moving-in.05-22.png`],
    [IconType.Live_out_5_23, `${ movingPath }/moving-in.05-23.png`],
    [IconType.Live_out_5_24, `${ movingPath }/moving-in.05-24.png`],
    [IconType.Live_out_5_25, `${ movingPath }/moving-in.05-25.png`],
    [IconType.Live_out_5_26, `${ movingPath }/moving-in.05-26.png`],
    [IconType.Live_out_5_27, `${ movingPath }/moving-in.05-27.png`],
    [IconType.Live_out_5_28, `${ movingPath }/moving-in.05-28.png`],
    [IconType.Live_out_5_29, `${ movingPath }/moving-in.05-29.png`],
    [IconType.Live_out_5_30, `${ movingPath }/moving-in.05-30.png`],
    [IconType.Live_out_5_31, `${ movingPath }/moving-in.05-31.png`],
    [IconType.Live_out_5_32, `${ movingPath }/moving-in.05-32.png`],
    [IconType.Live_out_5_33, `${ movingPath }/moving-in.05-33.png`],
    [IconType.Live_out_5_34, `${ movingPath }/moving-in.05-34.png`],
    [IconType.Live_out_5_35, `${ movingPath }/moving-in.05-35.png`],
    [IconType.Live_out_6_0, `${ movingPath }/moving-in.06-00.png`],
    [IconType.Live_out_6_1, `${ movingPath }/moving-in.06-01.png`],
    [IconType.Live_out_6_2, `${ movingPath }/moving-in.06-02.png`],
    [IconType.Live_out_6_3, `${ movingPath }/moving-in.06-03.png`],
    [IconType.Live_out_6_4, `${ movingPath }/moving-in.06-04.png`],
    [IconType.Live_out_6_5, `${ movingPath }/moving-in.06-05.png`],
    [IconType.Live_out_6_6, `${ movingPath }/moving-in.06-06.png`],
    [IconType.Live_out_6_7, `${ movingPath }/moving-in.06-07.png`],
    [IconType.Live_out_6_8, `${ movingPath }/moving-in.06-08.png`],
    [IconType.Live_out_6_9, `${ movingPath }/moving-in.06-09.png`],
    [IconType.Live_out_6_10, `${ movingPath }/moving-in.06-10.png`],
    [IconType.Live_out_6_11, `${ movingPath }/moving-in.06-11.png`],
    [IconType.Live_out_6_12, `${ movingPath }/moving-in.06-12.png`],
    [IconType.Live_out_6_13, `${ movingPath }/moving-in.06-13.png`],
    [IconType.Live_out_6_14, `${ movingPath }/moving-in.06-14.png`],
    [IconType.Live_out_6_15, `${ movingPath }/moving-in.06-15.png`],
    [IconType.Live_out_6_16, `${ movingPath }/moving-in.06-16.png`],
    [IconType.Live_out_6_17, `${ movingPath }/moving-in.06-17.png`],
    [IconType.Live_out_6_18, `${ movingPath }/moving-in.06-18.png`],
    [IconType.Live_out_6_19, `${ movingPath }/moving-in.06-19.png`],
    [IconType.Live_out_6_20, `${ movingPath }/moving-in.06-20.png`],
    [IconType.Live_out_6_21, `${ movingPath }/moving-in.06-21.png`],
    [IconType.Live_out_6_22, `${ movingPath }/moving-in.06-22.png`],
    [IconType.Live_out_6_23, `${ movingPath }/moving-in.06-23.png`],
    [IconType.Live_out_6_24, `${ movingPath }/moving-in.06-24.png`],
    [IconType.Live_out_6_25, `${ movingPath }/moving-in.06-25.png`],
    [IconType.Live_out_6_26, `${ movingPath }/moving-in.06-26.png`],
    [IconType.Live_out_6_27, `${ movingPath }/moving-in.06-27.png`],
    [IconType.Live_out_6_28, `${ movingPath }/moving-in.06-28.png`],
    [IconType.Live_out_6_29, `${ movingPath }/moving-in.06-29.png`],
    [IconType.Live_out_6_30, `${ movingPath }/moving-in.06-30.png`],
    [IconType.Live_out_6_31, `${ movingPath }/moving-in.06-31.png`],
    [IconType.Live_out_6_32, `${ movingPath }/moving-in.06-32.png`],
    [IconType.Live_out_6_33, `${ movingPath }/moving-in.06-33.png`],
    [IconType.Live_out_6_34, `${ movingPath }/moving-in.06-34.png`],
    [IconType.Live_out_6_35, `${ movingPath }/moving-in.06-35.png`],
    [IconType.Live_out_7_0, `${ movingPath }/moving-in.07-00.png`],
    [IconType.Live_out_7_1, `${ movingPath }/moving-in.07-01.png`],
    [IconType.Live_out_7_2, `${ movingPath }/moving-in.07-02.png`],
    [IconType.Live_out_7_3, `${ movingPath }/moving-in.07-03.png`],
    [IconType.Live_out_7_4, `${ movingPath }/moving-in.07-04.png`],
    [IconType.Live_out_7_5, `${ movingPath }/moving-in.07-05.png`],
    [IconType.Live_out_7_6, `${ movingPath }/moving-in.07-06.png`],
    [IconType.Live_out_7_7, `${ movingPath }/moving-in.07-07.png`],
    [IconType.Live_out_7_8, `${ movingPath }/moving-in.07-08.png`],
    [IconType.Live_out_7_9, `${ movingPath }/moving-in.07-09.png`],
    [IconType.Live_out_7_10, `${ movingPath }/moving-in.07-10.png`],
    [IconType.Live_out_7_11, `${ movingPath }/moving-in.07-11.png`],
    [IconType.Live_out_7_12, `${ movingPath }/moving-in.07-12.png`],
    [IconType.Live_out_7_13, `${ movingPath }/moving-in.07-13.png`],
    [IconType.Live_out_7_14, `${ movingPath }/moving-in.07-14.png`],
    [IconType.Live_out_7_15, `${ movingPath }/moving-in.07-15.png`],
    [IconType.Live_out_7_16, `${ movingPath }/moving-in.07-16.png`],
    [IconType.Live_out_7_17, `${ movingPath }/moving-in.07-17.png`],
    [IconType.Live_out_7_18, `${ movingPath }/moving-in.07-18.png`],
    [IconType.Live_out_7_19, `${ movingPath }/moving-in.07-19.png`],
    [IconType.Live_out_7_20, `${ movingPath }/moving-in.07-20.png`],
    [IconType.Live_out_7_21, `${ movingPath }/moving-in.07-21.png`],
    [IconType.Live_out_7_22, `${ movingPath }/moving-in.07-22.png`],
    [IconType.Live_out_7_23, `${ movingPath }/moving-in.07-23.png`],
    [IconType.Live_out_7_24, `${ movingPath }/moving-in.07-24.png`],
    [IconType.Live_out_7_25, `${ movingPath }/moving-in.07-25.png`],
    [IconType.Live_out_7_26, `${ movingPath }/moving-in.07-26.png`],
    [IconType.Live_out_7_27, `${ movingPath }/moving-in.07-27.png`],
    [IconType.Live_out_7_28, `${ movingPath }/moving-in.07-28.png`],
    [IconType.Live_out_7_29, `${ movingPath }/moving-in.07-29.png`],
    [IconType.Live_out_7_30, `${ movingPath }/moving-in.07-30.png`],
    [IconType.Live_out_7_31, `${ movingPath }/moving-in.07-31.png`],
    [IconType.Live_out_7_32, `${ movingPath }/moving-in.07-32.png`],
    [IconType.Live_out_7_33, `${ movingPath }/moving-in.07-33.png`],
    [IconType.Live_out_7_34, `${ movingPath }/moving-in.07-34.png`],
    [IconType.Live_out_7_35, `${ movingPath }/moving-in.07-35.png`],
    [IconType.Live_out_8_0, `${ movingPath }/moving-in.08-00.png`],
    [IconType.Live_out_8_1, `${ movingPath }/moving-in.08-01.png`],
    [IconType.Live_out_8_2, `${ movingPath }/moving-in.08-02.png`],
    [IconType.Live_out_8_3, `${ movingPath }/moving-in.08-03.png`],
    [IconType.Live_out_8_4, `${ movingPath }/moving-in.08-04.png`],
    [IconType.Live_out_8_5, `${ movingPath }/moving-in.08-05.png`],
    [IconType.Live_out_8_6, `${ movingPath }/moving-in.08-06.png`],
    [IconType.Live_out_8_7, `${ movingPath }/moving-in.08-07.png`],
    [IconType.Live_out_8_8, `${ movingPath }/moving-in.08-08.png`],
    [IconType.Live_out_8_9, `${ movingPath }/moving-in.08-09.png`],
    [IconType.Live_out_8_10, `${ movingPath }/moving-in.08-10.png`],
    [IconType.Live_out_8_11, `${ movingPath }/moving-in.08-11.png`],
    [IconType.Live_out_8_12, `${ movingPath }/moving-in.08-12.png`],
    [IconType.Live_out_8_13, `${ movingPath }/moving-in.08-13.png`],
    [IconType.Live_out_8_14, `${ movingPath }/moving-in.08-14.png`],
    [IconType.Live_out_8_15, `${ movingPath }/moving-in.08-15.png`],
    [IconType.Live_out_8_16, `${ movingPath }/moving-in.08-16.png`],
    [IconType.Live_out_8_17, `${ movingPath }/moving-in.08-17.png`],
    [IconType.Live_out_8_18, `${ movingPath }/moving-in.08-18.png`],
    [IconType.Live_out_8_19, `${ movingPath }/moving-in.08-19.png`],
    [IconType.Live_out_8_20, `${ movingPath }/moving-in.08-20.png`],
    [IconType.Live_out_8_21, `${ movingPath }/moving-in.08-21.png`],
    [IconType.Live_out_8_22, `${ movingPath }/moving-in.08-22.png`],
    [IconType.Live_out_8_23, `${ movingPath }/moving-in.08-23.png`],
    [IconType.Live_out_8_24, `${ movingPath }/moving-in.08-24.png`],
    [IconType.Live_out_8_25, `${ movingPath }/moving-in.08-25.png`],
    [IconType.Live_out_8_26, `${ movingPath }/moving-in.08-26.png`],
    [IconType.Live_out_8_27, `${ movingPath }/moving-in.08-27.png`],
    [IconType.Live_out_8_28, `${ movingPath }/moving-in.08-28.png`],
    [IconType.Live_out_8_29, `${ movingPath }/moving-in.08-29.png`],
    [IconType.Live_out_8_30, `${ movingPath }/moving-in.08-30.png`],
    [IconType.Live_out_8_31, `${ movingPath }/moving-in.08-31.png`],
    [IconType.Live_out_8_32, `${ movingPath }/moving-in.08-32.png`],
    [IconType.Live_out_8_33, `${ movingPath }/moving-in.08-33.png`],
    [IconType.Live_out_8_34, `${ movingPath }/moving-in.08-34.png`],
    [IconType.Live_out_8_35, `${ movingPath }/moving-in.08-35.png`],
    [IconType.Live_out_9_0, `${ movingPath }/moving-in.09-00.png`],
    [IconType.Live_out_9_1, `${ movingPath }/moving-in.09-01.png`],
    [IconType.Live_out_9_2, `${ movingPath }/moving-in.09-02.png`],
    [IconType.Live_out_9_3, `${ movingPath }/moving-in.09-03.png`],
    [IconType.Live_out_9_4, `${ movingPath }/moving-in.09-04.png`],
    [IconType.Live_out_9_5, `${ movingPath }/moving-in.09-05.png`],
    [IconType.Live_out_9_6, `${ movingPath }/moving-in.09-06.png`],
    [IconType.Live_out_9_7, `${ movingPath }/moving-in.09-07.png`],
    [IconType.Live_out_9_8, `${ movingPath }/moving-in.09-08.png`],
    [IconType.Live_out_9_9, `${ movingPath }/moving-in.09-09.png`],
    [IconType.Live_out_9_10, `${ movingPath }/moving-in.09-10.png`],
    [IconType.Live_out_9_11, `${ movingPath }/moving-in.09-11.png`],
    [IconType.Live_out_9_12, `${ movingPath }/moving-in.09-12.png`],
    [IconType.Live_out_9_13, `${ movingPath }/moving-in.09-13.png`],
    [IconType.Live_out_9_14, `${ movingPath }/moving-in.09-14.png`],
    [IconType.Live_out_9_15, `${ movingPath }/moving-in.09-15.png`],
    [IconType.Live_out_9_16, `${ movingPath }/moving-in.09-16.png`],
    [IconType.Live_out_9_17, `${ movingPath }/moving-in.09-17.png`],
    [IconType.Live_out_9_18, `${ movingPath }/moving-in.09-18.png`],
    [IconType.Live_out_9_19, `${ movingPath }/moving-in.09-19.png`],
    [IconType.Live_out_9_20, `${ movingPath }/moving-in.09-20.png`],
    [IconType.Live_out_9_21, `${ movingPath }/moving-in.09-21.png`],
    [IconType.Live_out_9_22, `${ movingPath }/moving-in.09-22.png`],
    [IconType.Live_out_9_23, `${ movingPath }/moving-in.09-23.png`],
    [IconType.Live_out_9_24, `${ movingPath }/moving-in.09-24.png`],
    [IconType.Live_out_9_25, `${ movingPath }/moving-in.09-25.png`],
    [IconType.Live_out_9_26, `${ movingPath }/moving-in.09-26.png`],
    [IconType.Live_out_9_27, `${ movingPath }/moving-in.09-27.png`],
    [IconType.Live_out_9_28, `${ movingPath }/moving-in.09-28.png`],
    [IconType.Live_out_9_29, `${ movingPath }/moving-in.09-29.png`],
    [IconType.Live_out_9_30, `${ movingPath }/moving-in.09-30.png`],
    [IconType.Live_out_9_31, `${ movingPath }/moving-in.09-31.png`],
    [IconType.Live_out_9_32, `${ movingPath }/moving-in.09-32.png`],
    [IconType.Live_out_9_33, `${ movingPath }/moving-in.09-33.png`],
    [IconType.Live_out_9_34, `${ movingPath }/moving-in.09-34.png`],
    [IconType.Live_out_9_35, `${ movingPath }/moving-in.09-35.png`],
    [IconType.Live_out_10_0, `${ movingPath }/moving-in.10-00.png`],
    [IconType.Live_out_10_1, `${ movingPath }/moving-in.10-01.png`],
    [IconType.Live_out_10_2, `${ movingPath }/moving-in.10-02.png`],
    [IconType.Live_out_10_3, `${ movingPath }/moving-in.10-03.png`],
    [IconType.Live_out_10_4, `${ movingPath }/moving-in.10-04.png`],
    [IconType.Live_out_10_5, `${ movingPath }/moving-in.10-05.png`],
    [IconType.Live_out_10_6, `${ movingPath }/moving-in.10-06.png`],
    [IconType.Live_out_10_7, `${ movingPath }/moving-in.10-07.png`],
    [IconType.Live_out_10_8, `${ movingPath }/moving-in.10-08.png`],
    [IconType.Live_out_10_9, `${ movingPath }/moving-in.10-09.png`],
    [IconType.Live_out_10_10, `${ movingPath }/moving-in.10-10.png`],
    [IconType.Live_out_10_11, `${ movingPath }/moving-in.10-11.png`],
    [IconType.Live_out_10_12, `${ movingPath }/moving-in.10-12.png`],
    [IconType.Live_out_10_13, `${ movingPath }/moving-in.10-13.png`],
    [IconType.Live_out_10_14, `${ movingPath }/moving-in.10-14.png`],
    [IconType.Live_out_10_15, `${ movingPath }/moving-in.10-15.png`],
    [IconType.Live_out_10_16, `${ movingPath }/moving-in.10-16.png`],
    [IconType.Live_out_10_17, `${ movingPath }/moving-in.10-17.png`],
    [IconType.Live_out_10_18, `${ movingPath }/moving-in.10-18.png`],
    [IconType.Live_out_10_19, `${ movingPath }/moving-in.10-19.png`],
    [IconType.Live_out_10_20, `${ movingPath }/moving-in.10-20.png`],
    [IconType.Live_out_10_21, `${ movingPath }/moving-in.10-21.png`],
    [IconType.Live_out_10_22, `${ movingPath }/moving-in.10-22.png`],
    [IconType.Live_out_10_23, `${ movingPath }/moving-in.10-23.png`],
    [IconType.Live_out_10_24, `${ movingPath }/moving-in.10-24.png`],
    [IconType.Live_out_10_25, `${ movingPath }/moving-in.10-25.png`],
    [IconType.Live_out_10_26, `${ movingPath }/moving-in.10-26.png`],
    [IconType.Live_out_10_27, `${ movingPath }/moving-in.10-27.png`],
    [IconType.Live_out_10_28, `${ movingPath }/moving-in.10-28.png`],
    [IconType.Live_out_10_29, `${ movingPath }/moving-in.10-29.png`],
    [IconType.Live_out_10_30, `${ movingPath }/moving-in.10-30.png`],
    [IconType.Live_out_10_31, `${ movingPath }/moving-in.10-31.png`],
    [IconType.Live_out_10_32, `${ movingPath }/moving-in.10-32.png`],
    [IconType.Live_out_10_33, `${ movingPath }/moving-in.10-33.png`],
    [IconType.Live_out_10_34, `${ movingPath }/moving-in.10-34.png`],
    [IconType.Live_out_10_35, `${ movingPath }/moving-in.10-35.png`],
    [IconType.Live_out_11_0, `${ movingPath }/moving-in.11-00.png`],
    [IconType.Live_out_11_1, `${ movingPath }/moving-in.11-01.png`],
    [IconType.Live_out_11_2, `${ movingPath }/moving-in.11-02.png`],
    [IconType.Live_out_11_3, `${ movingPath }/moving-in.11-03.png`],
    [IconType.Live_out_11_4, `${ movingPath }/moving-in.11-04.png`],
    [IconType.Live_out_11_5, `${ movingPath }/moving-in.11-05.png`],
    [IconType.Live_out_11_6, `${ movingPath }/moving-in.11-06.png`],
    [IconType.Live_out_11_7, `${ movingPath }/moving-in.11-07.png`],
    [IconType.Live_out_11_8, `${ movingPath }/moving-in.11-08.png`],
    [IconType.Live_out_11_9, `${ movingPath }/moving-in.11-09.png`],
    [IconType.Live_out_11_10, `${ movingPath }/moving-in.11-10.png`],
    [IconType.Live_out_11_11, `${ movingPath }/moving-in.11-11.png`],
    [IconType.Live_out_11_12, `${ movingPath }/moving-in.11-12.png`],
    [IconType.Live_out_11_13, `${ movingPath }/moving-in.11-13.png`],
    [IconType.Live_out_11_14, `${ movingPath }/moving-in.11-14.png`],
    [IconType.Live_out_11_15, `${ movingPath }/moving-in.11-15.png`],
    [IconType.Live_out_11_16, `${ movingPath }/moving-in.11-16.png`],
    [IconType.Live_out_11_17, `${ movingPath }/moving-in.11-17.png`],
    [IconType.Live_out_11_18, `${ movingPath }/moving-in.11-18.png`],
    [IconType.Live_out_11_19, `${ movingPath }/moving-in.11-19.png`],
    [IconType.Live_out_11_20, `${ movingPath }/moving-in.11-20.png`],
    [IconType.Live_out_11_21, `${ movingPath }/moving-in.11-21.png`],
    [IconType.Live_out_11_22, `${ movingPath }/moving-in.11-22.png`],
    [IconType.Live_out_11_23, `${ movingPath }/moving-in.11-23.png`],
    [IconType.Live_out_11_24, `${ movingPath }/moving-in.11-24.png`],
    [IconType.Live_out_11_25, `${ movingPath }/moving-in.11-25.png`],
    [IconType.Live_out_11_26, `${ movingPath }/moving-in.11-26.png`],
    [IconType.Live_out_11_27, `${ movingPath }/moving-in.11-27.png`],
    [IconType.Live_out_11_28, `${ movingPath }/moving-in.11-28.png`],
    [IconType.Live_out_11_29, `${ movingPath }/moving-in.11-29.png`],
    [IconType.Live_out_11_30, `${ movingPath }/moving-in.11-30.png`],
    [IconType.Live_out_11_31, `${ movingPath }/moving-in.11-31.png`],
    [IconType.Live_out_11_32, `${ movingPath }/moving-in.11-32.png`],
    [IconType.Live_out_11_33, `${ movingPath }/moving-in.11-33.png`],
    [IconType.Live_out_11_34, `${ movingPath }/moving-in.11-34.png`],
    [IconType.Live_out_11_35, `${ movingPath }/moving-in.11-35.png`],
    [IconType.Live_out_12_0, `${ movingPath }/moving-in.12-00.png`],
    [IconType.Live_out_12_1, `${ movingPath }/moving-in.12-01.png`],
    [IconType.Live_out_12_2, `${ movingPath }/moving-in.12-02.png`],
    [IconType.Live_out_12_3, `${ movingPath }/moving-in.12-03.png`],
    [IconType.Live_out_12_4, `${ movingPath }/moving-in.12-04.png`],
    [IconType.Live_out_12_5, `${ movingPath }/moving-in.12-05.png`],
    [IconType.Live_out_12_6, `${ movingPath }/moving-in.12-06.png`],
    [IconType.Live_out_12_7, `${ movingPath }/moving-in.12-07.png`],
    [IconType.Live_out_12_8, `${ movingPath }/moving-in.12-08.png`],
    [IconType.Live_out_12_9, `${ movingPath }/moving-in.12-09.png`],
    [IconType.Live_out_12_10, `${ movingPath }/moving-in.12-10.png`],
    [IconType.Live_out_12_11, `${ movingPath }/moving-in.12-11.png`],
    [IconType.Live_out_12_12, `${ movingPath }/moving-in.12-12.png`],
    [IconType.Live_out_12_13, `${ movingPath }/moving-in.12-13.png`],
    [IconType.Live_out_12_14, `${ movingPath }/moving-in.12-14.png`],
    [IconType.Live_out_12_15, `${ movingPath }/moving-in.12-15.png`],
    [IconType.Live_out_12_16, `${ movingPath }/moving-in.12-16.png`],
    [IconType.Live_out_12_17, `${ movingPath }/moving-in.12-17.png`],
    [IconType.Live_out_12_18, `${ movingPath }/moving-in.12-18.png`],
    [IconType.Live_out_12_19, `${ movingPath }/moving-in.12-19.png`],
    [IconType.Live_out_12_20, `${ movingPath }/moving-in.12-20.png`],
    [IconType.Live_out_12_21, `${ movingPath }/moving-in.12-21.png`],
    [IconType.Live_out_12_22, `${ movingPath }/moving-in.12-22.png`],
    [IconType.Live_out_12_23, `${ movingPath }/moving-in.12-23.png`],
    [IconType.Live_out_12_24, `${ movingPath }/moving-in.12-24.png`],
    [IconType.Live_out_12_25, `${ movingPath }/moving-in.12-25.png`],
    [IconType.Live_out_12_26, `${ movingPath }/moving-in.12-26.png`],
    [IconType.Live_out_12_27, `${ movingPath }/moving-in.12-27.png`],
    [IconType.Live_out_12_28, `${ movingPath }/moving-in.12-28.png`],
    [IconType.Live_out_12_29, `${ movingPath }/moving-in.12-29.png`],
    [IconType.Live_out_12_30, `${ movingPath }/moving-in.12-30.png`],
    [IconType.Live_out_12_31, `${ movingPath }/moving-in.12-31.png`],
    [IconType.Live_out_12_32, `${ movingPath }/moving-in.12-32.png`],
    [IconType.Live_out_12_33, `${ movingPath }/moving-in.12-33.png`],
    [IconType.Live_out_12_34, `${ movingPath }/moving-in.12-34.png`],
    [IconType.Live_out_12_35, `${ movingPath }/moving-in.12-35.png`],
    [IconType.Live_out_13_0, `${ movingPath }/moving-in.13-00.png`],
    [IconType.Live_out_13_1, `${ movingPath }/moving-in.13-01.png`],
    [IconType.Live_out_13_2, `${ movingPath }/moving-in.13-02.png`],
    [IconType.Live_out_13_3, `${ movingPath }/moving-in.13-03.png`],
    [IconType.Live_out_13_4, `${ movingPath }/moving-in.13-04.png`],
    [IconType.Live_out_13_5, `${ movingPath }/moving-in.13-05.png`],
    [IconType.Live_out_13_6, `${ movingPath }/moving-in.13-06.png`],
    [IconType.Live_out_13_7, `${ movingPath }/moving-in.13-07.png`],
    [IconType.Live_out_13_8, `${ movingPath }/moving-in.13-08.png`],
    [IconType.Live_out_13_9, `${ movingPath }/moving-in.13-09.png`],
    [IconType.Live_out_13_10, `${ movingPath }/moving-in.13-10.png`],
    [IconType.Live_out_13_11, `${ movingPath }/moving-in.13-11.png`],
    [IconType.Live_out_13_12, `${ movingPath }/moving-in.13-12.png`],
    [IconType.Live_out_13_13, `${ movingPath }/moving-in.13-13.png`],
    [IconType.Live_out_13_14, `${ movingPath }/moving-in.13-14.png`],
    [IconType.Live_out_13_15, `${ movingPath }/moving-in.13-15.png`],
    [IconType.Live_out_13_16, `${ movingPath }/moving-in.13-16.png`],
    [IconType.Live_out_13_17, `${ movingPath }/moving-in.13-17.png`],
    [IconType.Live_out_13_18, `${ movingPath }/moving-in.13-18.png`],
    [IconType.Live_out_13_19, `${ movingPath }/moving-in.13-19.png`],
    [IconType.Live_out_13_20, `${ movingPath }/moving-in.13-20.png`],
    [IconType.Live_out_13_21, `${ movingPath }/moving-in.13-21.png`],
    [IconType.Live_out_13_22, `${ movingPath }/moving-in.13-22.png`],
    [IconType.Live_out_13_23, `${ movingPath }/moving-in.13-23.png`],
    [IconType.Live_out_13_24, `${ movingPath }/moving-in.13-24.png`],
    [IconType.Live_out_13_25, `${ movingPath }/moving-in.13-25.png`],
    [IconType.Live_out_13_26, `${ movingPath }/moving-in.13-26.png`],
    [IconType.Live_out_13_27, `${ movingPath }/moving-in.13-27.png`],
    [IconType.Live_out_13_28, `${ movingPath }/moving-in.13-28.png`],
    [IconType.Live_out_13_29, `${ movingPath }/moving-in.13-29.png`],
    [IconType.Live_out_13_30, `${ movingPath }/moving-in.13-30.png`],
    [IconType.Live_out_13_31, `${ movingPath }/moving-in.13-31.png`],
    [IconType.Live_out_13_32, `${ movingPath }/moving-in.13-32.png`],
    [IconType.Live_out_13_33, `${ movingPath }/moving-in.13-33.png`],
    [IconType.Live_out_13_34, `${ movingPath }/moving-in.13-34.png`],
    [IconType.Live_out_13_35, `${ movingPath }/moving-in.13-35.png`],
    [IconType.Live_out_14_0, `${ movingPath }/moving-in.14-00.png`],
    [IconType.Live_out_14_1, `${ movingPath }/moving-in.14-01.png`],
    [IconType.Live_out_14_2, `${ movingPath }/moving-in.14-02.png`],
    [IconType.Live_out_14_3, `${ movingPath }/moving-in.14-03.png`],
    [IconType.Live_out_14_4, `${ movingPath }/moving-in.14-04.png`],
    [IconType.Live_out_14_5, `${ movingPath }/moving-in.14-05.png`],
    [IconType.Live_out_14_6, `${ movingPath }/moving-in.14-06.png`],
    [IconType.Live_out_14_7, `${ movingPath }/moving-in.14-07.png`],
    [IconType.Live_out_14_8, `${ movingPath }/moving-in.14-08.png`],
    [IconType.Live_out_14_9, `${ movingPath }/moving-in.14-09.png`],
    [IconType.Live_out_14_10, `${ movingPath }/moving-in.14-10.png`],
    [IconType.Live_out_14_11, `${ movingPath }/moving-in.14-11.png`],
    [IconType.Live_out_14_12, `${ movingPath }/moving-in.14-12.png`],
    [IconType.Live_out_14_13, `${ movingPath }/moving-in.14-13.png`],
    [IconType.Live_out_14_14, `${ movingPath }/moving-in.14-14.png`],
    [IconType.Live_out_14_15, `${ movingPath }/moving-in.14-15.png`],
    [IconType.Live_out_14_16, `${ movingPath }/moving-in.14-16.png`],
    [IconType.Live_out_14_17, `${ movingPath }/moving-in.14-17.png`],
    [IconType.Live_out_14_18, `${ movingPath }/moving-in.14-18.png`],
    [IconType.Live_out_14_19, `${ movingPath }/moving-in.14-19.png`],
    [IconType.Live_out_14_20, `${ movingPath }/moving-in.14-20.png`],
    [IconType.Live_out_14_21, `${ movingPath }/moving-in.14-21.png`],
    [IconType.Live_out_14_22, `${ movingPath }/moving-in.14-22.png`],
    [IconType.Live_out_14_23, `${ movingPath }/moving-in.14-23.png`],
    [IconType.Live_out_14_24, `${ movingPath }/moving-in.14-24.png`],
    [IconType.Live_out_14_25, `${ movingPath }/moving-in.14-25.png`],
    [IconType.Live_out_14_26, `${ movingPath }/moving-in.14-26.png`],
    [IconType.Live_out_14_27, `${ movingPath }/moving-in.14-27.png`],
    [IconType.Live_out_14_28, `${ movingPath }/moving-in.14-28.png`],
    [IconType.Live_out_14_29, `${ movingPath }/moving-in.14-29.png`],
    [IconType.Live_out_14_30, `${ movingPath }/moving-in.14-30.png`],
    [IconType.Live_out_14_31, `${ movingPath }/moving-in.14-31.png`],
    [IconType.Live_out_14_32, `${ movingPath }/moving-in.14-32.png`],
    [IconType.Live_out_14_33, `${ movingPath }/moving-in.14-33.png`],
    [IconType.Live_out_14_34, `${ movingPath }/moving-in.14-34.png`],
    [IconType.Live_out_14_35, `${ movingPath }/moving-in.14-35.png`],
    [IconType.Live_out_15_0, `${ movingPath }/moving-in.15-00.png`],
    [IconType.Live_out_15_1, `${ movingPath }/moving-in.15-01.png`],
    [IconType.Live_out_15_2, `${ movingPath }/moving-in.15-02.png`],
    [IconType.Live_out_15_3, `${ movingPath }/moving-in.15-03.png`],
    [IconType.Live_out_15_4, `${ movingPath }/moving-in.15-04.png`],
    [IconType.Live_out_15_5, `${ movingPath }/moving-in.15-05.png`],
    [IconType.Live_out_15_6, `${ movingPath }/moving-in.15-06.png`],
    [IconType.Live_out_15_7, `${ movingPath }/moving-in.15-07.png`],
    [IconType.Live_out_15_8, `${ movingPath }/moving-in.15-08.png`],
    [IconType.Live_out_15_9, `${ movingPath }/moving-in.15-09.png`],
    [IconType.Live_out_15_10, `${ movingPath }/moving-in.15-10.png`],
    [IconType.Live_out_15_11, `${ movingPath }/moving-in.15-11.png`],
    [IconType.Live_out_15_12, `${ movingPath }/moving-in.15-12.png`],
    [IconType.Live_out_15_13, `${ movingPath }/moving-in.15-13.png`],
    [IconType.Live_out_15_14, `${ movingPath }/moving-in.15-14.png`],
    [IconType.Live_out_15_15, `${ movingPath }/moving-in.15-15.png`],
    [IconType.Live_out_15_16, `${ movingPath }/moving-in.15-16.png`],
    [IconType.Live_out_15_17, `${ movingPath }/moving-in.15-17.png`],
    [IconType.Live_out_15_18, `${ movingPath }/moving-in.15-18.png`],
    [IconType.Live_out_15_19, `${ movingPath }/moving-in.15-19.png`],
    [IconType.Live_out_15_20, `${ movingPath }/moving-in.15-20.png`],
    [IconType.Live_out_15_21, `${ movingPath }/moving-in.15-21.png`],
    [IconType.Live_out_15_22, `${ movingPath }/moving-in.15-22.png`],
    [IconType.Live_out_15_23, `${ movingPath }/moving-in.15-23.png`],
    [IconType.Live_out_15_24, `${ movingPath }/moving-in.15-24.png`],
    [IconType.Live_out_15_25, `${ movingPath }/moving-in.15-25.png`],
    [IconType.Live_out_15_26, `${ movingPath }/moving-in.15-26.png`],
    [IconType.Live_out_15_27, `${ movingPath }/moving-in.15-27.png`],
    [IconType.Live_out_15_28, `${ movingPath }/moving-in.15-28.png`],
    [IconType.Live_out_15_29, `${ movingPath }/moving-in.15-29.png`],
    [IconType.Live_out_15_30, `${ movingPath }/moving-in.15-30.png`],
    [IconType.Live_out_15_31, `${ movingPath }/moving-in.15-31.png`],
    [IconType.Live_out_15_32, `${ movingPath }/moving-in.15-32.png`],
    [IconType.Live_out_15_33, `${ movingPath }/moving-in.15-33.png`],
    [IconType.Live_out_15_34, `${ movingPath }/moving-in.15-34.png`],
    [IconType.Live_out_15_35, `${ movingPath }/moving-in.15-35.png`],
    [IconType.Live_out_16_0, `${ movingPath }/moving-in.16-00.png`],
    [IconType.Live_out_16_1, `${ movingPath }/moving-in.16-01.png`],
    [IconType.Live_out_16_2, `${ movingPath }/moving-in.16-02.png`],
    [IconType.Live_out_16_3, `${ movingPath }/moving-in.16-03.png`],
    [IconType.Live_out_16_4, `${ movingPath }/moving-in.16-04.png`],
    [IconType.Live_out_16_5, `${ movingPath }/moving-in.16-05.png`],
    [IconType.Live_out_16_6, `${ movingPath }/moving-in.16-06.png`],
    [IconType.Live_out_16_7, `${ movingPath }/moving-in.16-07.png`],
    [IconType.Live_out_16_8, `${ movingPath }/moving-in.16-08.png`],
    [IconType.Live_out_16_9, `${ movingPath }/moving-in.16-09.png`],
    [IconType.Live_out_16_10, `${ movingPath }/moving-in.16-10.png`],
    [IconType.Live_out_16_11, `${ movingPath }/moving-in.16-11.png`],
    [IconType.Live_out_16_12, `${ movingPath }/moving-in.16-12.png`],
    [IconType.Live_out_16_13, `${ movingPath }/moving-in.16-13.png`],
    [IconType.Live_out_16_14, `${ movingPath }/moving-in.16-14.png`],
    [IconType.Live_out_16_15, `${ movingPath }/moving-in.16-15.png`],
    [IconType.Live_out_16_16, `${ movingPath }/moving-in.16-16.png`],
    [IconType.Live_out_16_17, `${ movingPath }/moving-in.16-17.png`],
    [IconType.Live_out_16_18, `${ movingPath }/moving-in.16-18.png`],
    [IconType.Live_out_16_19, `${ movingPath }/moving-in.16-19.png`],
    [IconType.Live_out_16_20, `${ movingPath }/moving-in.16-20.png`],
    [IconType.Live_out_16_21, `${ movingPath }/moving-in.16-21.png`],
    [IconType.Live_out_16_22, `${ movingPath }/moving-in.16-22.png`],
    [IconType.Live_out_16_23, `${ movingPath }/moving-in.16-23.png`],
    [IconType.Live_out_16_24, `${ movingPath }/moving-in.16-24.png`],
    [IconType.Live_out_16_25, `${ movingPath }/moving-in.16-25.png`],
    [IconType.Live_out_16_26, `${ movingPath }/moving-in.16-26.png`],
    [IconType.Live_out_16_27, `${ movingPath }/moving-in.16-27.png`],
    [IconType.Live_out_16_28, `${ movingPath }/moving-in.16-28.png`],
    [IconType.Live_out_16_29, `${ movingPath }/moving-in.16-29.png`],
    [IconType.Live_out_16_30, `${ movingPath }/moving-in.16-30.png`],
    [IconType.Live_out_16_31, `${ movingPath }/moving-in.16-31.png`],
    [IconType.Live_out_16_32, `${ movingPath }/moving-in.16-32.png`],
    [IconType.Live_out_16_33, `${ movingPath }/moving-in.16-33.png`],
    [IconType.Live_out_16_34, `${ movingPath }/moving-in.16-34.png`],
    [IconType.Live_out_16_35, `${ movingPath }/moving-in.16-35.png`],
    [IconType.Live_out_17_0, `${ movingPath }/moving-in.17-00.png`],
    [IconType.Live_out_17_1, `${ movingPath }/moving-in.17-01.png`],
    [IconType.Live_out_17_2, `${ movingPath }/moving-in.17-02.png`],
    [IconType.Live_out_17_3, `${ movingPath }/moving-in.17-03.png`],
    [IconType.Live_out_17_4, `${ movingPath }/moving-in.17-04.png`],
    [IconType.Live_out_17_5, `${ movingPath }/moving-in.17-05.png`],
    [IconType.Live_out_17_6, `${ movingPath }/moving-in.17-06.png`],
    [IconType.Live_out_17_7, `${ movingPath }/moving-in.17-07.png`],
    [IconType.Live_out_17_8, `${ movingPath }/moving-in.17-08.png`],
    [IconType.Live_out_17_9, `${ movingPath }/moving-in.17-09.png`],
    [IconType.Live_out_17_10, `${ movingPath }/moving-in.17-10.png`],
    [IconType.Live_out_17_11, `${ movingPath }/moving-in.17-11.png`],
    [IconType.Live_out_17_12, `${ movingPath }/moving-in.17-12.png`],
    [IconType.Live_out_17_13, `${ movingPath }/moving-in.17-13.png`],
    [IconType.Live_out_17_14, `${ movingPath }/moving-in.17-14.png`],
    [IconType.Live_out_17_15, `${ movingPath }/moving-in.17-15.png`],
    [IconType.Live_out_17_16, `${ movingPath }/moving-in.17-16.png`],
    [IconType.Live_out_17_17, `${ movingPath }/moving-in.17-17.png`],
    [IconType.Live_out_17_18, `${ movingPath }/moving-in.17-18.png`],
    [IconType.Live_out_17_19, `${ movingPath }/moving-in.17-19.png`],
    [IconType.Live_out_17_20, `${ movingPath }/moving-in.17-20.png`],
    [IconType.Live_out_17_21, `${ movingPath }/moving-in.17-21.png`],
    [IconType.Live_out_17_22, `${ movingPath }/moving-in.17-22.png`],
    [IconType.Live_out_17_23, `${ movingPath }/moving-in.17-23.png`],
    [IconType.Live_out_17_24, `${ movingPath }/moving-in.17-24.png`],
    [IconType.Live_out_17_25, `${ movingPath }/moving-in.17-25.png`],
    [IconType.Live_out_17_26, `${ movingPath }/moving-in.17-26.png`],
    [IconType.Live_out_17_27, `${ movingPath }/moving-in.17-27.png`],
    [IconType.Live_out_17_28, `${ movingPath }/moving-in.17-28.png`],
    [IconType.Live_out_17_29, `${ movingPath }/moving-in.17-29.png`],
    [IconType.Live_out_17_30, `${ movingPath }/moving-in.17-30.png`],
    [IconType.Live_out_17_31, `${ movingPath }/moving-in.17-31.png`],
    [IconType.Live_out_17_32, `${ movingPath }/moving-in.17-32.png`],
    [IconType.Live_out_17_33, `${ movingPath }/moving-in.17-33.png`],
    [IconType.Live_out_17_34, `${ movingPath }/moving-in.17-34.png`],
    [IconType.Live_out_17_35, `${ movingPath }/moving-in.17-35.png`],
    [IconType.Live_out_18_0, `${ movingPath }/moving-in.18-00.png`],
    [IconType.Live_out_18_1, `${ movingPath }/moving-in.18-01.png`],
    [IconType.Live_out_18_2, `${ movingPath }/moving-in.18-02.png`],
    [IconType.Live_out_18_3, `${ movingPath }/moving-in.18-03.png`],
    [IconType.Live_out_18_4, `${ movingPath }/moving-in.18-04.png`],
    [IconType.Live_out_18_5, `${ movingPath }/moving-in.18-05.png`],
    [IconType.Live_out_18_6, `${ movingPath }/moving-in.18-06.png`],
    [IconType.Live_out_18_7, `${ movingPath }/moving-in.18-07.png`],
    [IconType.Live_out_18_8, `${ movingPath }/moving-in.18-08.png`],
    [IconType.Live_out_18_9, `${ movingPath }/moving-in.18-09.png`],
    [IconType.Live_out_18_10, `${ movingPath }/moving-in.18-10.png`],
    [IconType.Live_out_18_11, `${ movingPath }/moving-in.18-11.png`],
    [IconType.Live_out_18_12, `${ movingPath }/moving-in.18-12.png`],
    [IconType.Live_out_18_13, `${ movingPath }/moving-in.18-13.png`],
    [IconType.Live_out_18_14, `${ movingPath }/moving-in.18-14.png`],
    [IconType.Live_out_18_15, `${ movingPath }/moving-in.18-15.png`],
    [IconType.Live_out_18_16, `${ movingPath }/moving-in.18-16.png`],
    [IconType.Live_out_18_17, `${ movingPath }/moving-in.18-17.png`],
    [IconType.Live_out_18_18, `${ movingPath }/moving-in.18-18.png`],
    [IconType.Live_out_18_19, `${ movingPath }/moving-in.18-19.png`],
    [IconType.Live_out_18_20, `${ movingPath }/moving-in.18-20.png`],
    [IconType.Live_out_18_21, `${ movingPath }/moving-in.18-21.png`],
    [IconType.Live_out_18_22, `${ movingPath }/moving-in.18-22.png`],
    [IconType.Live_out_18_23, `${ movingPath }/moving-in.18-23.png`],
    [IconType.Live_out_18_24, `${ movingPath }/moving-in.18-24.png`],
    [IconType.Live_out_18_25, `${ movingPath }/moving-in.18-25.png`],
    [IconType.Live_out_18_26, `${ movingPath }/moving-in.18-26.png`],
    [IconType.Live_out_18_27, `${ movingPath }/moving-in.18-27.png`],
    [IconType.Live_out_18_28, `${ movingPath }/moving-in.18-28.png`],
    [IconType.Live_out_18_29, `${ movingPath }/moving-in.18-29.png`],
    [IconType.Live_out_18_30, `${ movingPath }/moving-in.18-30.png`],
    [IconType.Live_out_18_31, `${ movingPath }/moving-in.18-31.png`],
    [IconType.Live_out_18_32, `${ movingPath }/moving-in.18-32.png`],
    [IconType.Live_out_18_33, `${ movingPath }/moving-in.18-33.png`],
    [IconType.Live_out_18_34, `${ movingPath }/moving-in.18-34.png`],
    [IconType.Live_out_18_35, `${ movingPath }/moving-in.18-35.png`]
]);

const iconLinks3 = new Map<IconType, string>([
    [IconType.Live_0_0, `${ movingPath }/moving-in.00-00.png`],
    [IconType.Live_0_1, `${ movingPath }/moving-in.00-01.png`],
    [IconType.Live_0_2, `${ movingPath }/moving-in.00-02.png`],
    [IconType.Live_0_3, `${ movingPath }/moving-in.00-03.png`],
    [IconType.Live_0_4, `${ movingPath }/moving-in.00-04.png`],
    [IconType.Live_0_5, `${ movingPath }/moving-in.00-05.png`],
    [IconType.Live_0_6, `${ movingPath }/moving-in.00-06.png`],
    [IconType.Live_0_7, `${ movingPath }/moving-in.00-07.png`],
    [IconType.Live_0_8, `${ movingPath }/moving-in.00-08.png`],
    [IconType.Live_0_9, `${ movingPath }/moving-in.00-09.png`],
    [IconType.Live_0_10, `${ movingPath }/moving-in.00-10.png`],
    [IconType.Live_0_11, `${ movingPath }/moving-in.00-11.png`],
    [IconType.Live_0_12, `${ movingPath }/moving-in.00-12.png`],
    [IconType.Live_0_13, `${ movingPath }/moving-in.00-13.png`],
    [IconType.Live_0_14, `${ movingPath }/moving-in.00-14.png`],
    [IconType.Live_0_15, `${ movingPath }/moving-in.00-15.png`],
    [IconType.Live_0_16, `${ movingPath }/moving-in.00-16.png`],
    [IconType.Live_0_17, `${ movingPath }/moving-in.00-17.png`],
    [IconType.Live_0_18, `${ movingPath }/moving-in.00-18.png`],
    [IconType.Live_0_19, `${ movingPath }/moving-in.00-19.png`],
    [IconType.Live_0_20, `${ movingPath }/moving-in.00-20.png`],
    [IconType.Live_0_21, `${ movingPath }/moving-in.00-21.png`],
    [IconType.Live_0_22, `${ movingPath }/moving-in.00-22.png`],
    [IconType.Live_0_23, `${ movingPath }/moving-in.00-23.png`],
    [IconType.Live_0_24, `${ movingPath }/moving-in.00-24.png`],
    [IconType.Live_0_25, `${ movingPath }/moving-in.00-25.png`],
    [IconType.Live_0_26, `${ movingPath }/moving-in.00-26.png`],
    [IconType.Live_0_27, `${ movingPath }/moving-in.00-27.png`],
    [IconType.Live_0_28, `${ movingPath }/moving-in.00-28.png`],
    [IconType.Live_0_29, `${ movingPath }/moving-in.00-29.png`],
    [IconType.Live_0_30, `${ movingPath }/moving-in.00-30.png`],
    [IconType.Live_0_31, `${ movingPath }/moving-in.00-31.png`],
    [IconType.Live_0_32, `${ movingPath }/moving-in.00-32.png`],
    [IconType.Live_0_33, `${ movingPath }/moving-in.00-33.png`],
    [IconType.Live_0_34, `${ movingPath }/moving-in.00-34.png`],
    [IconType.Live_0_35, `${ movingPath }/moving-in.00-35.png`],
    [IconType.Live_1_0, `${ movingPath }/moving-in.01-00.png`],
    [IconType.Live_1_1, `${ movingPath }/moving-in.01-01.png`],
    [IconType.Live_1_2, `${ movingPath }/moving-in.01-02.png`],
    [IconType.Live_1_3, `${ movingPath }/moving-in.01-03.png`],
    [IconType.Live_1_4, `${ movingPath }/moving-in.01-04.png`],
    [IconType.Live_1_5, `${ movingPath }/moving-in.01-05.png`],
    [IconType.Live_1_6, `${ movingPath }/moving-in.01-06.png`],
    [IconType.Live_1_7, `${ movingPath }/moving-in.01-07.png`],
    [IconType.Live_1_8, `${ movingPath }/moving-in.01-08.png`],
    [IconType.Live_1_9, `${ movingPath }/moving-in.01-09.png`],
    [IconType.Live_1_10, `${ movingPath }/moving-in.01-10.png`],
    [IconType.Live_1_11, `${ movingPath }/moving-in.01-11.png`],
    [IconType.Live_1_12, `${ movingPath }/moving-in.01-12.png`],
    [IconType.Live_1_13, `${ movingPath }/moving-in.01-13.png`],
    [IconType.Live_1_14, `${ movingPath }/moving-in.01-14.png`],
    [IconType.Live_1_15, `${ movingPath }/moving-in.01-15.png`],
    [IconType.Live_1_16, `${ movingPath }/moving-in.01-16.png`],
    [IconType.Live_1_17, `${ movingPath }/moving-in.01-17.png`],
    [IconType.Live_1_18, `${ movingPath }/moving-in.01-18.png`],
    [IconType.Live_1_19, `${ movingPath }/moving-in.01-19.png`],
    [IconType.Live_1_20, `${ movingPath }/moving-in.01-20.png`],
    [IconType.Live_1_21, `${ movingPath }/moving-in.01-21.png`],
    [IconType.Live_1_22, `${ movingPath }/moving-in.01-22.png`],
    [IconType.Live_1_23, `${ movingPath }/moving-in.01-23.png`],
    [IconType.Live_1_24, `${ movingPath }/moving-in.01-24.png`],
    [IconType.Live_1_25, `${ movingPath }/moving-in.01-25.png`],
    [IconType.Live_1_26, `${ movingPath }/moving-in.01-26.png`],
    [IconType.Live_1_27, `${ movingPath }/moving-in.01-27.png`],
    [IconType.Live_1_28, `${ movingPath }/moving-in.01-28.png`],
    [IconType.Live_1_29, `${ movingPath }/moving-in.01-29.png`],
    [IconType.Live_1_30, `${ movingPath }/moving-in.01-30.png`],
    [IconType.Live_1_31, `${ movingPath }/moving-in.01-31.png`],
    [IconType.Live_1_32, `${ movingPath }/moving-in.01-32.png`],
    [IconType.Live_1_33, `${ movingPath }/moving-in.01-33.png`],
    [IconType.Live_1_34, `${ movingPath }/moving-in.01-34.png`],
    [IconType.Live_1_35, `${ movingPath }/moving-in.01-35.png`],
    [IconType.Live_2_0, `${ movingPath }/moving-in.02-00.png`],
    [IconType.Live_2_1, `${ movingPath }/moving-in.02-01.png`],
    [IconType.Live_2_2, `${ movingPath }/moving-in.02-02.png`],
    [IconType.Live_2_3, `${ movingPath }/moving-in.02-03.png`],
    [IconType.Live_2_4, `${ movingPath }/moving-in.02-04.png`],
    [IconType.Live_2_5, `${ movingPath }/moving-in.02-05.png`],
    [IconType.Live_2_6, `${ movingPath }/moving-in.02-06.png`],
    [IconType.Live_2_7, `${ movingPath }/moving-in.02-07.png`],
    [IconType.Live_2_8, `${ movingPath }/moving-in.02-08.png`],
    [IconType.Live_2_9, `${ movingPath }/moving-in.02-09.png`],
    [IconType.Live_2_10, `${ movingPath }/moving-in.02-10.png`],
    [IconType.Live_2_11, `${ movingPath }/moving-in.02-11.png`],
    [IconType.Live_2_12, `${ movingPath }/moving-in.02-12.png`],
    [IconType.Live_2_13, `${ movingPath }/moving-in.02-13.png`],
    [IconType.Live_2_14, `${ movingPath }/moving-in.02-14.png`],
    [IconType.Live_2_15, `${ movingPath }/moving-in.02-15.png`],
    [IconType.Live_2_16, `${ movingPath }/moving-in.02-16.png`],
    [IconType.Live_2_17, `${ movingPath }/moving-in.02-17.png`],
    [IconType.Live_2_18, `${ movingPath }/moving-in.02-18.png`],
    [IconType.Live_2_19, `${ movingPath }/moving-in.02-19.png`],
    [IconType.Live_2_20, `${ movingPath }/moving-in.02-20.png`],
    [IconType.Live_2_21, `${ movingPath }/moving-in.02-21.png`],
    [IconType.Live_2_22, `${ movingPath }/moving-in.02-22.png`],
    [IconType.Live_2_23, `${ movingPath }/moving-in.02-23.png`],
    [IconType.Live_2_24, `${ movingPath }/moving-in.02-24.png`],
    [IconType.Live_2_25, `${ movingPath }/moving-in.02-25.png`],
    [IconType.Live_2_26, `${ movingPath }/moving-in.02-26.png`],
    [IconType.Live_2_27, `${ movingPath }/moving-in.02-27.png`],
    [IconType.Live_2_28, `${ movingPath }/moving-in.02-28.png`],
    [IconType.Live_2_29, `${ movingPath }/moving-in.02-29.png`],
    [IconType.Live_2_30, `${ movingPath }/moving-in.02-30.png`],
    [IconType.Live_2_31, `${ movingPath }/moving-in.02-31.png`],
    [IconType.Live_2_32, `${ movingPath }/moving-in.02-32.png`],
    [IconType.Live_2_33, `${ movingPath }/moving-in.02-33.png`],
    [IconType.Live_2_34, `${ movingPath }/moving-in.02-34.png`],
    [IconType.Live_2_35, `${ movingPath }/moving-in.02-35.png`],
    [IconType.Live_3_0, `${ movingPath }/moving-in.03-00.png`],
    [IconType.Live_3_1, `${ movingPath }/moving-in.03-01.png`],
    [IconType.Live_3_2, `${ movingPath }/moving-in.03-02.png`],
    [IconType.Live_3_3, `${ movingPath }/moving-in.03-03.png`],
    [IconType.Live_3_4, `${ movingPath }/moving-in.03-04.png`],
    [IconType.Live_3_5, `${ movingPath }/moving-in.03-05.png`],
    [IconType.Live_3_6, `${ movingPath }/moving-in.03-06.png`],
    [IconType.Live_3_7, `${ movingPath }/moving-in.03-07.png`],
    [IconType.Live_3_8, `${ movingPath }/moving-in.03-08.png`],
    [IconType.Live_3_9, `${ movingPath }/moving-in.03-09.png`],
    [IconType.Live_3_10, `${ movingPath }/moving-in.03-10.png`],
    [IconType.Live_3_11, `${ movingPath }/moving-in.03-11.png`],
    [IconType.Live_3_12, `${ movingPath }/moving-in.03-12.png`],
    [IconType.Live_3_13, `${ movingPath }/moving-in.03-13.png`],
    [IconType.Live_3_14, `${ movingPath }/moving-in.03-14.png`],
    [IconType.Live_3_15, `${ movingPath }/moving-in.03-15.png`],
    [IconType.Live_3_16, `${ movingPath }/moving-in.03-16.png`],
    [IconType.Live_3_17, `${ movingPath }/moving-in.03-17.png`],
    [IconType.Live_3_18, `${ movingPath }/moving-in.03-18.png`],
    [IconType.Live_3_19, `${ movingPath }/moving-in.03-19.png`],
    [IconType.Live_3_20, `${ movingPath }/moving-in.03-20.png`],
    [IconType.Live_3_21, `${ movingPath }/moving-in.03-21.png`],
    [IconType.Live_3_22, `${ movingPath }/moving-in.03-22.png`],
    [IconType.Live_3_23, `${ movingPath }/moving-in.03-23.png`],
    [IconType.Live_3_24, `${ movingPath }/moving-in.03-24.png`],
    [IconType.Live_3_25, `${ movingPath }/moving-in.03-25.png`],
    [IconType.Live_3_26, `${ movingPath }/moving-in.03-26.png`],
    [IconType.Live_3_27, `${ movingPath }/moving-in.03-27.png`],
    [IconType.Live_3_28, `${ movingPath }/moving-in.03-28.png`],
    [IconType.Live_3_29, `${ movingPath }/moving-in.03-29.png`],
    [IconType.Live_3_30, `${ movingPath }/moving-in.03-30.png`],
    [IconType.Live_3_31, `${ movingPath }/moving-in.03-31.png`],
    [IconType.Live_3_32, `${ movingPath }/moving-in.03-32.png`],
    [IconType.Live_3_33, `${ movingPath }/moving-in.03-33.png`],
    [IconType.Live_3_34, `${ movingPath }/moving-in.03-34.png`],
    [IconType.Live_3_35, `${ movingPath }/moving-in.03-35.png`],
    [IconType.Live_4_0, `${ movingPath }/moving-in.04-00.png`],
    [IconType.Live_4_1, `${ movingPath }/moving-in.04-01.png`],
    [IconType.Live_4_2, `${ movingPath }/moving-in.04-02.png`],
    [IconType.Live_4_3, `${ movingPath }/moving-in.04-03.png`],
    [IconType.Live_4_4, `${ movingPath }/moving-in.04-04.png`],
    [IconType.Live_4_5, `${ movingPath }/moving-in.04-05.png`],
    [IconType.Live_4_6, `${ movingPath }/moving-in.04-06.png`],
    [IconType.Live_4_7, `${ movingPath }/moving-in.04-07.png`],
    [IconType.Live_4_8, `${ movingPath }/moving-in.04-08.png`],
    [IconType.Live_4_9, `${ movingPath }/moving-in.04-09.png`],
    [IconType.Live_4_10, `${ movingPath }/moving-in.04-10.png`],
    [IconType.Live_4_11, `${ movingPath }/moving-in.04-11.png`],
    [IconType.Live_4_12, `${ movingPath }/moving-in.04-12.png`],
    [IconType.Live_4_13, `${ movingPath }/moving-in.04-13.png`],
    [IconType.Live_4_14, `${ movingPath }/moving-in.04-14.png`],
    [IconType.Live_4_15, `${ movingPath }/moving-in.04-15.png`],
    [IconType.Live_4_16, `${ movingPath }/moving-in.04-16.png`],
    [IconType.Live_4_17, `${ movingPath }/moving-in.04-17.png`],
    [IconType.Live_4_18, `${ movingPath }/moving-in.04-18.png`],
    [IconType.Live_4_19, `${ movingPath }/moving-in.04-19.png`],
    [IconType.Live_4_20, `${ movingPath }/moving-in.04-20.png`],
    [IconType.Live_4_21, `${ movingPath }/moving-in.04-21.png`],
    [IconType.Live_4_22, `${ movingPath }/moving-in.04-22.png`],
    [IconType.Live_4_23, `${ movingPath }/moving-in.04-23.png`],
    [IconType.Live_4_24, `${ movingPath }/moving-in.04-24.png`],
    [IconType.Live_4_25, `${ movingPath }/moving-in.04-25.png`],
    [IconType.Live_4_26, `${ movingPath }/moving-in.04-26.png`],
    [IconType.Live_4_27, `${ movingPath }/moving-in.04-27.png`],
    [IconType.Live_4_28, `${ movingPath }/moving-in.04-28.png`],
    [IconType.Live_4_29, `${ movingPath }/moving-in.04-29.png`],
    [IconType.Live_4_30, `${ movingPath }/moving-in.04-30.png`],
    [IconType.Live_4_31, `${ movingPath }/moving-in.04-31.png`],
    [IconType.Live_4_32, `${ movingPath }/moving-in.04-32.png`],
    [IconType.Live_4_33, `${ movingPath }/moving-in.04-33.png`],
    [IconType.Live_4_34, `${ movingPath }/moving-in.04-34.png`],
    [IconType.Live_4_35, `${ movingPath }/moving-in.04-35.png`],
    [IconType.Live_5_0, `${ movingPath }/moving-in.05-00.png`],
    [IconType.Live_5_1, `${ movingPath }/moving-in.05-01.png`],
    [IconType.Live_5_2, `${ movingPath }/moving-in.05-02.png`],
    [IconType.Live_5_3, `${ movingPath }/moving-in.05-03.png`],
    [IconType.Live_5_4, `${ movingPath }/moving-in.05-04.png`],
    [IconType.Live_5_5, `${ movingPath }/moving-in.05-05.png`],
    [IconType.Live_5_6, `${ movingPath }/moving-in.05-06.png`],
    [IconType.Live_5_7, `${ movingPath }/moving-in.05-07.png`],
    [IconType.Live_5_8, `${ movingPath }/moving-in.05-08.png`],
    [IconType.Live_5_9, `${ movingPath }/moving-in.05-09.png`],
    [IconType.Live_5_10, `${ movingPath }/moving-in.05-10.png`],
    [IconType.Live_5_11, `${ movingPath }/moving-in.05-11.png`],
    [IconType.Live_5_12, `${ movingPath }/moving-in.05-12.png`],
    [IconType.Live_5_13, `${ movingPath }/moving-in.05-13.png`],
    [IconType.Live_5_14, `${ movingPath }/moving-in.05-14.png`],
    [IconType.Live_5_15, `${ movingPath }/moving-in.05-15.png`],
    [IconType.Live_5_16, `${ movingPath }/moving-in.05-16.png`],
    [IconType.Live_5_17, `${ movingPath }/moving-in.05-17.png`],
    [IconType.Live_5_18, `${ movingPath }/moving-in.05-18.png`],
    [IconType.Live_5_19, `${ movingPath }/moving-in.05-19.png`],
    [IconType.Live_5_20, `${ movingPath }/moving-in.05-20.png`],
    [IconType.Live_5_21, `${ movingPath }/moving-in.05-21.png`],
    [IconType.Live_5_22, `${ movingPath }/moving-in.05-22.png`],
    [IconType.Live_5_23, `${ movingPath }/moving-in.05-23.png`],
    [IconType.Live_5_24, `${ movingPath }/moving-in.05-24.png`],
    [IconType.Live_5_25, `${ movingPath }/moving-in.05-25.png`],
    [IconType.Live_5_26, `${ movingPath }/moving-in.05-26.png`],
    [IconType.Live_5_27, `${ movingPath }/moving-in.05-27.png`],
    [IconType.Live_5_28, `${ movingPath }/moving-in.05-28.png`],
    [IconType.Live_5_29, `${ movingPath }/moving-in.05-29.png`],
    [IconType.Live_5_30, `${ movingPath }/moving-in.05-30.png`],
    [IconType.Live_5_31, `${ movingPath }/moving-in.05-31.png`],
    [IconType.Live_5_32, `${ movingPath }/moving-in.05-32.png`],
    [IconType.Live_5_33, `${ movingPath }/moving-in.05-33.png`],
    [IconType.Live_5_34, `${ movingPath }/moving-in.05-34.png`],
    [IconType.Live_5_35, `${ movingPath }/moving-in.05-35.png`],
    [IconType.Live_6_0, `${ movingPath }/moving-in.06-00.png`],
    [IconType.Live_6_1, `${ movingPath }/moving-in.06-01.png`],
    [IconType.Live_6_2, `${ movingPath }/moving-in.06-02.png`],
    [IconType.Live_6_3, `${ movingPath }/moving-in.06-03.png`],
    [IconType.Live_6_4, `${ movingPath }/moving-in.06-04.png`],
    [IconType.Live_6_5, `${ movingPath }/moving-in.06-05.png`],
    [IconType.Live_6_6, `${ movingPath }/moving-in.06-06.png`],
    [IconType.Live_6_7, `${ movingPath }/moving-in.06-07.png`],
    [IconType.Live_6_8, `${ movingPath }/moving-in.06-08.png`],
    [IconType.Live_6_9, `${ movingPath }/moving-in.06-09.png`],
    [IconType.Live_6_10, `${ movingPath }/moving-in.06-10.png`],
    [IconType.Live_6_11, `${ movingPath }/moving-in.06-11.png`],
    [IconType.Live_6_12, `${ movingPath }/moving-in.06-12.png`],
    [IconType.Live_6_13, `${ movingPath }/moving-in.06-13.png`],
    [IconType.Live_6_14, `${ movingPath }/moving-in.06-14.png`],
    [IconType.Live_6_15, `${ movingPath }/moving-in.06-15.png`],
    [IconType.Live_6_16, `${ movingPath }/moving-in.06-16.png`],
    [IconType.Live_6_17, `${ movingPath }/moving-in.06-17.png`],
    [IconType.Live_6_18, `${ movingPath }/moving-in.06-18.png`],
    [IconType.Live_6_19, `${ movingPath }/moving-in.06-19.png`],
    [IconType.Live_6_20, `${ movingPath }/moving-in.06-20.png`],
    [IconType.Live_6_21, `${ movingPath }/moving-in.06-21.png`],
    [IconType.Live_6_22, `${ movingPath }/moving-in.06-22.png`],
    [IconType.Live_6_23, `${ movingPath }/moving-in.06-23.png`],
    [IconType.Live_6_24, `${ movingPath }/moving-in.06-24.png`],
    [IconType.Live_6_25, `${ movingPath }/moving-in.06-25.png`],
    [IconType.Live_6_26, `${ movingPath }/moving-in.06-26.png`],
    [IconType.Live_6_27, `${ movingPath }/moving-in.06-27.png`],
    [IconType.Live_6_28, `${ movingPath }/moving-in.06-28.png`],
    [IconType.Live_6_29, `${ movingPath }/moving-in.06-29.png`],
    [IconType.Live_6_30, `${ movingPath }/moving-in.06-30.png`],
    [IconType.Live_6_31, `${ movingPath }/moving-in.06-31.png`],
    [IconType.Live_6_32, `${ movingPath }/moving-in.06-32.png`],
    [IconType.Live_6_33, `${ movingPath }/moving-in.06-33.png`],
    [IconType.Live_6_34, `${ movingPath }/moving-in.06-34.png`],
    [IconType.Live_6_35, `${ movingPath }/moving-in.06-35.png`],
    [IconType.Live_7_0, `${ movingPath }/moving-in.07-00.png`],
    [IconType.Live_7_1, `${ movingPath }/moving-in.07-01.png`],
    [IconType.Live_7_2, `${ movingPath }/moving-in.07-02.png`],
    [IconType.Live_7_3, `${ movingPath }/moving-in.07-03.png`],
    [IconType.Live_7_4, `${ movingPath }/moving-in.07-04.png`],
    [IconType.Live_7_5, `${ movingPath }/moving-in.07-05.png`],
    [IconType.Live_7_6, `${ movingPath }/moving-in.07-06.png`],
    [IconType.Live_7_7, `${ movingPath }/moving-in.07-07.png`],
    [IconType.Live_7_8, `${ movingPath }/moving-in.07-08.png`],
    [IconType.Live_7_9, `${ movingPath }/moving-in.07-09.png`],
    [IconType.Live_7_10, `${ movingPath }/moving-in.07-10.png`],
    [IconType.Live_7_11, `${ movingPath }/moving-in.07-11.png`],
    [IconType.Live_7_12, `${ movingPath }/moving-in.07-12.png`],
    [IconType.Live_7_13, `${ movingPath }/moving-in.07-13.png`],
    [IconType.Live_7_14, `${ movingPath }/moving-in.07-14.png`],
    [IconType.Live_7_15, `${ movingPath }/moving-in.07-15.png`],
    [IconType.Live_7_16, `${ movingPath }/moving-in.07-16.png`],
    [IconType.Live_7_17, `${ movingPath }/moving-in.07-17.png`],
    [IconType.Live_7_18, `${ movingPath }/moving-in.07-18.png`],
    [IconType.Live_7_19, `${ movingPath }/moving-in.07-19.png`],
    [IconType.Live_7_20, `${ movingPath }/moving-in.07-20.png`],
    [IconType.Live_7_21, `${ movingPath }/moving-in.07-21.png`],
    [IconType.Live_7_22, `${ movingPath }/moving-in.07-22.png`],
    [IconType.Live_7_23, `${ movingPath }/moving-in.07-23.png`],
    [IconType.Live_7_24, `${ movingPath }/moving-in.07-24.png`],
    [IconType.Live_7_25, `${ movingPath }/moving-in.07-25.png`],
    [IconType.Live_7_26, `${ movingPath }/moving-in.07-26.png`],
    [IconType.Live_7_27, `${ movingPath }/moving-in.07-27.png`],
    [IconType.Live_7_28, `${ movingPath }/moving-in.07-28.png`],
    [IconType.Live_7_29, `${ movingPath }/moving-in.07-29.png`],
    [IconType.Live_7_30, `${ movingPath }/moving-in.07-30.png`],
    [IconType.Live_7_31, `${ movingPath }/moving-in.07-31.png`],
    [IconType.Live_7_32, `${ movingPath }/moving-in.07-32.png`],
    [IconType.Live_7_33, `${ movingPath }/moving-in.07-33.png`],
    [IconType.Live_7_34, `${ movingPath }/moving-in.07-34.png`],
    [IconType.Live_7_35, `${ movingPath }/moving-in.07-35.png`],
    [IconType.Live_8_0, `${ movingPath }/moving-in.08-00.png`],
    [IconType.Live_8_1, `${ movingPath }/moving-in.08-01.png`],
    [IconType.Live_8_2, `${ movingPath }/moving-in.08-02.png`],
    [IconType.Live_8_3, `${ movingPath }/moving-in.08-03.png`],
    [IconType.Live_8_4, `${ movingPath }/moving-in.08-04.png`],
    [IconType.Live_8_5, `${ movingPath }/moving-in.08-05.png`],
    [IconType.Live_8_6, `${ movingPath }/moving-in.08-06.png`],
    [IconType.Live_8_7, `${ movingPath }/moving-in.08-07.png`],
    [IconType.Live_8_8, `${ movingPath }/moving-in.08-08.png`],
    [IconType.Live_8_9, `${ movingPath }/moving-in.08-09.png`],
    [IconType.Live_8_10, `${ movingPath }/moving-in.08-10.png`],
    [IconType.Live_8_11, `${ movingPath }/moving-in.08-11.png`],
    [IconType.Live_8_12, `${ movingPath }/moving-in.08-12.png`],
    [IconType.Live_8_13, `${ movingPath }/moving-in.08-13.png`],
    [IconType.Live_8_14, `${ movingPath }/moving-in.08-14.png`],
    [IconType.Live_8_15, `${ movingPath }/moving-in.08-15.png`],
    [IconType.Live_8_16, `${ movingPath }/moving-in.08-16.png`],
    [IconType.Live_8_17, `${ movingPath }/moving-in.08-17.png`],
    [IconType.Live_8_18, `${ movingPath }/moving-in.08-18.png`],
    [IconType.Live_8_19, `${ movingPath }/moving-in.08-19.png`],
    [IconType.Live_8_20, `${ movingPath }/moving-in.08-20.png`],
    [IconType.Live_8_21, `${ movingPath }/moving-in.08-21.png`],
    [IconType.Live_8_22, `${ movingPath }/moving-in.08-22.png`],
    [IconType.Live_8_23, `${ movingPath }/moving-in.08-23.png`],
    [IconType.Live_8_24, `${ movingPath }/moving-in.08-24.png`],
    [IconType.Live_8_25, `${ movingPath }/moving-in.08-25.png`],
    [IconType.Live_8_26, `${ movingPath }/moving-in.08-26.png`],
    [IconType.Live_8_27, `${ movingPath }/moving-in.08-27.png`],
    [IconType.Live_8_28, `${ movingPath }/moving-in.08-28.png`],
    [IconType.Live_8_29, `${ movingPath }/moving-in.08-29.png`],
    [IconType.Live_8_30, `${ movingPath }/moving-in.08-30.png`],
    [IconType.Live_8_31, `${ movingPath }/moving-in.08-31.png`],
    [IconType.Live_8_32, `${ movingPath }/moving-in.08-32.png`],
    [IconType.Live_8_33, `${ movingPath }/moving-in.08-33.png`],
    [IconType.Live_8_34, `${ movingPath }/moving-in.08-34.png`],
    [IconType.Live_8_35, `${ movingPath }/moving-in.08-35.png`],
    [IconType.Live_9_0, `${ movingPath }/moving-in.09-00.png`],
    [IconType.Live_9_1, `${ movingPath }/moving-in.09-01.png`],
    [IconType.Live_9_2, `${ movingPath }/moving-in.09-02.png`],
    [IconType.Live_9_3, `${ movingPath }/moving-in.09-03.png`],
    [IconType.Live_9_4, `${ movingPath }/moving-in.09-04.png`],
    [IconType.Live_9_5, `${ movingPath }/moving-in.09-05.png`],
    [IconType.Live_9_6, `${ movingPath }/moving-in.09-06.png`],
    [IconType.Live_9_7, `${ movingPath }/moving-in.09-07.png`],
    [IconType.Live_9_8, `${ movingPath }/moving-in.09-08.png`],
    [IconType.Live_9_9, `${ movingPath }/moving-in.09-09.png`],
    [IconType.Live_9_10, `${ movingPath }/moving-in.09-10.png`],
    [IconType.Live_9_11, `${ movingPath }/moving-in.09-11.png`],
    [IconType.Live_9_12, `${ movingPath }/moving-in.09-12.png`],
    [IconType.Live_9_13, `${ movingPath }/moving-in.09-13.png`],
    [IconType.Live_9_14, `${ movingPath }/moving-in.09-14.png`],
    [IconType.Live_9_15, `${ movingPath }/moving-in.09-15.png`],
    [IconType.Live_9_16, `${ movingPath }/moving-in.09-16.png`],
    [IconType.Live_9_17, `${ movingPath }/moving-in.09-17.png`],
    [IconType.Live_9_18, `${ movingPath }/moving-in.09-18.png`],
    [IconType.Live_9_19, `${ movingPath }/moving-in.09-19.png`],
    [IconType.Live_9_20, `${ movingPath }/moving-in.09-20.png`],
    [IconType.Live_9_21, `${ movingPath }/moving-in.09-21.png`],
    [IconType.Live_9_22, `${ movingPath }/moving-in.09-22.png`],
    [IconType.Live_9_23, `${ movingPath }/moving-in.09-23.png`],
    [IconType.Live_9_24, `${ movingPath }/moving-in.09-24.png`],
    [IconType.Live_9_25, `${ movingPath }/moving-in.09-25.png`],
    [IconType.Live_9_26, `${ movingPath }/moving-in.09-26.png`],
    [IconType.Live_9_27, `${ movingPath }/moving-in.09-27.png`],
    [IconType.Live_9_28, `${ movingPath }/moving-in.09-28.png`],
    [IconType.Live_9_29, `${ movingPath }/moving-in.09-29.png`],
    [IconType.Live_9_30, `${ movingPath }/moving-in.09-30.png`],
    [IconType.Live_9_31, `${ movingPath }/moving-in.09-31.png`],
    [IconType.Live_9_32, `${ movingPath }/moving-in.09-32.png`],
    [IconType.Live_9_33, `${ movingPath }/moving-in.09-33.png`],
    [IconType.Live_9_34, `${ movingPath }/moving-in.09-34.png`],
    [IconType.Live_9_35, `${ movingPath }/moving-in.09-35.png`],
    [IconType.Live_10_0, `${ movingPath }/moving-in.10-00.png`],
    [IconType.Live_10_1, `${ movingPath }/moving-in.10-01.png`],
    [IconType.Live_10_2, `${ movingPath }/moving-in.10-02.png`],
    [IconType.Live_10_3, `${ movingPath }/moving-in.10-03.png`],
    [IconType.Live_10_4, `${ movingPath }/moving-in.10-04.png`],
    [IconType.Live_10_5, `${ movingPath }/moving-in.10-05.png`],
    [IconType.Live_10_6, `${ movingPath }/moving-in.10-06.png`],
    [IconType.Live_10_7, `${ movingPath }/moving-in.10-07.png`],
    [IconType.Live_10_8, `${ movingPath }/moving-in.10-08.png`],
    [IconType.Live_10_9, `${ movingPath }/moving-in.10-09.png`],
    [IconType.Live_10_10, `${ movingPath }/moving-in.10-10.png`],
    [IconType.Live_10_11, `${ movingPath }/moving-in.10-11.png`],
    [IconType.Live_10_12, `${ movingPath }/moving-in.10-12.png`],
    [IconType.Live_10_13, `${ movingPath }/moving-in.10-13.png`],
    [IconType.Live_10_14, `${ movingPath }/moving-in.10-14.png`],
    [IconType.Live_10_15, `${ movingPath }/moving-in.10-15.png`],
    [IconType.Live_10_16, `${ movingPath }/moving-in.10-16.png`],
    [IconType.Live_10_17, `${ movingPath }/moving-in.10-17.png`],
    [IconType.Live_10_18, `${ movingPath }/moving-in.10-18.png`],
    [IconType.Live_10_19, `${ movingPath }/moving-in.10-19.png`],
    [IconType.Live_10_20, `${ movingPath }/moving-in.10-20.png`],
    [IconType.Live_10_21, `${ movingPath }/moving-in.10-21.png`],
    [IconType.Live_10_22, `${ movingPath }/moving-in.10-22.png`],
    [IconType.Live_10_23, `${ movingPath }/moving-in.10-23.png`],
    [IconType.Live_10_24, `${ movingPath }/moving-in.10-24.png`],
    [IconType.Live_10_25, `${ movingPath }/moving-in.10-25.png`],
    [IconType.Live_10_26, `${ movingPath }/moving-in.10-26.png`],
    [IconType.Live_10_27, `${ movingPath }/moving-in.10-27.png`],
    [IconType.Live_10_28, `${ movingPath }/moving-in.10-28.png`],
    [IconType.Live_10_29, `${ movingPath }/moving-in.10-29.png`],
    [IconType.Live_10_30, `${ movingPath }/moving-in.10-30.png`],
    [IconType.Live_10_31, `${ movingPath }/moving-in.10-31.png`],
    [IconType.Live_10_32, `${ movingPath }/moving-in.10-32.png`],
    [IconType.Live_10_33, `${ movingPath }/moving-in.10-33.png`],
    [IconType.Live_10_34, `${ movingPath }/moving-in.10-34.png`],
    [IconType.Live_10_35, `${ movingPath }/moving-in.10-35.png`],
    [IconType.Live_11_0, `${ movingPath }/moving-in.11-00.png`],
    [IconType.Live_11_1, `${ movingPath }/moving-in.11-01.png`],
    [IconType.Live_11_2, `${ movingPath }/moving-in.11-02.png`],
    [IconType.Live_11_3, `${ movingPath }/moving-in.11-03.png`],
    [IconType.Live_11_4, `${ movingPath }/moving-in.11-04.png`],
    [IconType.Live_11_5, `${ movingPath }/moving-in.11-05.png`],
    [IconType.Live_11_6, `${ movingPath }/moving-in.11-06.png`],
    [IconType.Live_11_7, `${ movingPath }/moving-in.11-07.png`],
    [IconType.Live_11_8, `${ movingPath }/moving-in.11-08.png`],
    [IconType.Live_11_9, `${ movingPath }/moving-in.11-09.png`],
    [IconType.Live_11_10, `${ movingPath }/moving-in.11-10.png`],
    [IconType.Live_11_11, `${ movingPath }/moving-in.11-11.png`],
    [IconType.Live_11_12, `${ movingPath }/moving-in.11-12.png`],
    [IconType.Live_11_13, `${ movingPath }/moving-in.11-13.png`],
    [IconType.Live_11_14, `${ movingPath }/moving-in.11-14.png`],
    [IconType.Live_11_15, `${ movingPath }/moving-in.11-15.png`],
    [IconType.Live_11_16, `${ movingPath }/moving-in.11-16.png`],
    [IconType.Live_11_17, `${ movingPath }/moving-in.11-17.png`],
    [IconType.Live_11_18, `${ movingPath }/moving-in.11-18.png`],
    [IconType.Live_11_19, `${ movingPath }/moving-in.11-19.png`],
    [IconType.Live_11_20, `${ movingPath }/moving-in.11-20.png`],
    [IconType.Live_11_21, `${ movingPath }/moving-in.11-21.png`],
    [IconType.Live_11_22, `${ movingPath }/moving-in.11-22.png`],
    [IconType.Live_11_23, `${ movingPath }/moving-in.11-23.png`],
    [IconType.Live_11_24, `${ movingPath }/moving-in.11-24.png`],
    [IconType.Live_11_25, `${ movingPath }/moving-in.11-25.png`],
    [IconType.Live_11_26, `${ movingPath }/moving-in.11-26.png`],
    [IconType.Live_11_27, `${ movingPath }/moving-in.11-27.png`],
    [IconType.Live_11_28, `${ movingPath }/moving-in.11-28.png`],
    [IconType.Live_11_29, `${ movingPath }/moving-in.11-29.png`],
    [IconType.Live_11_30, `${ movingPath }/moving-in.11-30.png`],
    [IconType.Live_11_31, `${ movingPath }/moving-in.11-31.png`],
    [IconType.Live_11_32, `${ movingPath }/moving-in.11-32.png`],
    [IconType.Live_11_33, `${ movingPath }/moving-in.11-33.png`],
    [IconType.Live_11_34, `${ movingPath }/moving-in.11-34.png`],
    [IconType.Live_11_35, `${ movingPath }/moving-in.11-35.png`],
    [IconType.Live_12_0, `${ movingPath }/moving-in.12-00.png`],
    [IconType.Live_12_1, `${ movingPath }/moving-in.12-01.png`],
    [IconType.Live_12_2, `${ movingPath }/moving-in.12-02.png`],
    [IconType.Live_12_3, `${ movingPath }/moving-in.12-03.png`],
    [IconType.Live_12_4, `${ movingPath }/moving-in.12-04.png`],
    [IconType.Live_12_5, `${ movingPath }/moving-in.12-05.png`],
    [IconType.Live_12_6, `${ movingPath }/moving-in.12-06.png`],
    [IconType.Live_12_7, `${ movingPath }/moving-in.12-07.png`],
    [IconType.Live_12_8, `${ movingPath }/moving-in.12-08.png`],
    [IconType.Live_12_9, `${ movingPath }/moving-in.12-09.png`],
    [IconType.Live_12_10, `${ movingPath }/moving-in.12-10.png`],
    [IconType.Live_12_11, `${ movingPath }/moving-in.12-11.png`],
    [IconType.Live_12_12, `${ movingPath }/moving-in.12-12.png`],
    [IconType.Live_12_13, `${ movingPath }/moving-in.12-13.png`],
    [IconType.Live_12_14, `${ movingPath }/moving-in.12-14.png`],
    [IconType.Live_12_15, `${ movingPath }/moving-in.12-15.png`],
    [IconType.Live_12_16, `${ movingPath }/moving-in.12-16.png`],
    [IconType.Live_12_17, `${ movingPath }/moving-in.12-17.png`],
    [IconType.Live_12_18, `${ movingPath }/moving-in.12-18.png`],
    [IconType.Live_12_19, `${ movingPath }/moving-in.12-19.png`],
    [IconType.Live_12_20, `${ movingPath }/moving-in.12-20.png`],
    [IconType.Live_12_21, `${ movingPath }/moving-in.12-21.png`],
    [IconType.Live_12_22, `${ movingPath }/moving-in.12-22.png`],
    [IconType.Live_12_23, `${ movingPath }/moving-in.12-23.png`],
    [IconType.Live_12_24, `${ movingPath }/moving-in.12-24.png`],
    [IconType.Live_12_25, `${ movingPath }/moving-in.12-25.png`],
    [IconType.Live_12_26, `${ movingPath }/moving-in.12-26.png`],
    [IconType.Live_12_27, `${ movingPath }/moving-in.12-27.png`],
    [IconType.Live_12_28, `${ movingPath }/moving-in.12-28.png`],
    [IconType.Live_12_29, `${ movingPath }/moving-in.12-29.png`],
    [IconType.Live_12_30, `${ movingPath }/moving-in.12-30.png`],
    [IconType.Live_12_31, `${ movingPath }/moving-in.12-31.png`],
    [IconType.Live_12_32, `${ movingPath }/moving-in.12-32.png`],
    [IconType.Live_12_33, `${ movingPath }/moving-in.12-33.png`],
    [IconType.Live_12_34, `${ movingPath }/moving-in.12-34.png`],
    [IconType.Live_12_35, `${ movingPath }/moving-in.12-35.png`],
    [IconType.Live_13_0, `${ movingPath }/moving-in.13-00.png`],
    [IconType.Live_13_1, `${ movingPath }/moving-in.13-01.png`],
    [IconType.Live_13_2, `${ movingPath }/moving-in.13-02.png`],
    [IconType.Live_13_3, `${ movingPath }/moving-in.13-03.png`],
    [IconType.Live_13_4, `${ movingPath }/moving-in.13-04.png`],
    [IconType.Live_13_5, `${ movingPath }/moving-in.13-05.png`],
    [IconType.Live_13_6, `${ movingPath }/moving-in.13-06.png`],
    [IconType.Live_13_7, `${ movingPath }/moving-in.13-07.png`],
    [IconType.Live_13_8, `${ movingPath }/moving-in.13-08.png`],
    [IconType.Live_13_9, `${ movingPath }/moving-in.13-09.png`],
    [IconType.Live_13_10, `${ movingPath }/moving-in.13-10.png`],
    [IconType.Live_13_11, `${ movingPath }/moving-in.13-11.png`],
    [IconType.Live_13_12, `${ movingPath }/moving-in.13-12.png`],
    [IconType.Live_13_13, `${ movingPath }/moving-in.13-13.png`],
    [IconType.Live_13_14, `${ movingPath }/moving-in.13-14.png`],
    [IconType.Live_13_15, `${ movingPath }/moving-in.13-15.png`],
    [IconType.Live_13_16, `${ movingPath }/moving-in.13-16.png`],
    [IconType.Live_13_17, `${ movingPath }/moving-in.13-17.png`],
    [IconType.Live_13_18, `${ movingPath }/moving-in.13-18.png`],
    [IconType.Live_13_19, `${ movingPath }/moving-in.13-19.png`],
    [IconType.Live_13_20, `${ movingPath }/moving-in.13-20.png`],
    [IconType.Live_13_21, `${ movingPath }/moving-in.13-21.png`],
    [IconType.Live_13_22, `${ movingPath }/moving-in.13-22.png`],
    [IconType.Live_13_23, `${ movingPath }/moving-in.13-23.png`],
    [IconType.Live_13_24, `${ movingPath }/moving-in.13-24.png`],
    [IconType.Live_13_25, `${ movingPath }/moving-in.13-25.png`],
    [IconType.Live_13_26, `${ movingPath }/moving-in.13-26.png`],
    [IconType.Live_13_27, `${ movingPath }/moving-in.13-27.png`],
    [IconType.Live_13_28, `${ movingPath }/moving-in.13-28.png`],
    [IconType.Live_13_29, `${ movingPath }/moving-in.13-29.png`],
    [IconType.Live_13_30, `${ movingPath }/moving-in.13-30.png`],
    [IconType.Live_13_31, `${ movingPath }/moving-in.13-31.png`],
    [IconType.Live_13_32, `${ movingPath }/moving-in.13-32.png`],
    [IconType.Live_13_33, `${ movingPath }/moving-in.13-33.png`],
    [IconType.Live_13_34, `${ movingPath }/moving-in.13-34.png`],
    [IconType.Live_13_35, `${ movingPath }/moving-in.13-35.png`],
    [IconType.Live_14_0, `${ movingPath }/moving-in.14-00.png`],
    [IconType.Live_14_1, `${ movingPath }/moving-in.14-01.png`],
    [IconType.Live_14_2, `${ movingPath }/moving-in.14-02.png`],
    [IconType.Live_14_3, `${ movingPath }/moving-in.14-03.png`],
    [IconType.Live_14_4, `${ movingPath }/moving-in.14-04.png`],
    [IconType.Live_14_5, `${ movingPath }/moving-in.14-05.png`],
    [IconType.Live_14_6, `${ movingPath }/moving-in.14-06.png`],
    [IconType.Live_14_7, `${ movingPath }/moving-in.14-07.png`],
    [IconType.Live_14_8, `${ movingPath }/moving-in.14-08.png`],
    [IconType.Live_14_9, `${ movingPath }/moving-in.14-09.png`],
    [IconType.Live_14_10, `${ movingPath }/moving-in.14-10.png`],
    [IconType.Live_14_11, `${ movingPath }/moving-in.14-11.png`],
    [IconType.Live_14_12, `${ movingPath }/moving-in.14-12.png`],
    [IconType.Live_14_13, `${ movingPath }/moving-in.14-13.png`],
    [IconType.Live_14_14, `${ movingPath }/moving-in.14-14.png`],
    [IconType.Live_14_15, `${ movingPath }/moving-in.14-15.png`],
    [IconType.Live_14_16, `${ movingPath }/moving-in.14-16.png`],
    [IconType.Live_14_17, `${ movingPath }/moving-in.14-17.png`],
    [IconType.Live_14_18, `${ movingPath }/moving-in.14-18.png`],
    [IconType.Live_14_19, `${ movingPath }/moving-in.14-19.png`],
    [IconType.Live_14_20, `${ movingPath }/moving-in.14-20.png`],
    [IconType.Live_14_21, `${ movingPath }/moving-in.14-21.png`],
    [IconType.Live_14_22, `${ movingPath }/moving-in.14-22.png`],
    [IconType.Live_14_23, `${ movingPath }/moving-in.14-23.png`],
    [IconType.Live_14_24, `${ movingPath }/moving-in.14-24.png`],
    [IconType.Live_14_25, `${ movingPath }/moving-in.14-25.png`],
    [IconType.Live_14_26, `${ movingPath }/moving-in.14-26.png`],
    [IconType.Live_14_27, `${ movingPath }/moving-in.14-27.png`],
    [IconType.Live_14_28, `${ movingPath }/moving-in.14-28.png`],
    [IconType.Live_14_29, `${ movingPath }/moving-in.14-29.png`],
    [IconType.Live_14_30, `${ movingPath }/moving-in.14-30.png`],
    [IconType.Live_14_31, `${ movingPath }/moving-in.14-31.png`],
    [IconType.Live_14_32, `${ movingPath }/moving-in.14-32.png`],
    [IconType.Live_14_33, `${ movingPath }/moving-in.14-33.png`],
    [IconType.Live_14_34, `${ movingPath }/moving-in.14-34.png`],
    [IconType.Live_14_35, `${ movingPath }/moving-in.14-35.png`],
    [IconType.Live_15_0, `${ movingPath }/moving-in.15-00.png`],
    [IconType.Live_15_1, `${ movingPath }/moving-in.15-01.png`],
    [IconType.Live_15_2, `${ movingPath }/moving-in.15-02.png`],
    [IconType.Live_15_3, `${ movingPath }/moving-in.15-03.png`],
    [IconType.Live_15_4, `${ movingPath }/moving-in.15-04.png`],
    [IconType.Live_15_5, `${ movingPath }/moving-in.15-05.png`],
    [IconType.Live_15_6, `${ movingPath }/moving-in.15-06.png`],
    [IconType.Live_15_7, `${ movingPath }/moving-in.15-07.png`],
    [IconType.Live_15_8, `${ movingPath }/moving-in.15-08.png`],
    [IconType.Live_15_9, `${ movingPath }/moving-in.15-09.png`],
    [IconType.Live_15_10, `${ movingPath }/moving-in.15-10.png`],
    [IconType.Live_15_11, `${ movingPath }/moving-in.15-11.png`],
    [IconType.Live_15_12, `${ movingPath }/moving-in.15-12.png`],
    [IconType.Live_15_13, `${ movingPath }/moving-in.15-13.png`],
    [IconType.Live_15_14, `${ movingPath }/moving-in.15-14.png`],
    [IconType.Live_15_15, `${ movingPath }/moving-in.15-15.png`],
    [IconType.Live_15_16, `${ movingPath }/moving-in.15-16.png`],
    [IconType.Live_15_17, `${ movingPath }/moving-in.15-17.png`],
    [IconType.Live_15_18, `${ movingPath }/moving-in.15-18.png`],
    [IconType.Live_15_19, `${ movingPath }/moving-in.15-19.png`],
    [IconType.Live_15_20, `${ movingPath }/moving-in.15-20.png`],
    [IconType.Live_15_21, `${ movingPath }/moving-in.15-21.png`],
    [IconType.Live_15_22, `${ movingPath }/moving-in.15-22.png`],
    [IconType.Live_15_23, `${ movingPath }/moving-in.15-23.png`],
    [IconType.Live_15_24, `${ movingPath }/moving-in.15-24.png`],
    [IconType.Live_15_25, `${ movingPath }/moving-in.15-25.png`],
    [IconType.Live_15_26, `${ movingPath }/moving-in.15-26.png`],
    [IconType.Live_15_27, `${ movingPath }/moving-in.15-27.png`],
    [IconType.Live_15_28, `${ movingPath }/moving-in.15-28.png`],
    [IconType.Live_15_29, `${ movingPath }/moving-in.15-29.png`],
    [IconType.Live_15_30, `${ movingPath }/moving-in.15-30.png`],
    [IconType.Live_15_31, `${ movingPath }/moving-in.15-31.png`],
    [IconType.Live_15_32, `${ movingPath }/moving-in.15-32.png`],
    [IconType.Live_15_33, `${ movingPath }/moving-in.15-33.png`],
    [IconType.Live_15_34, `${ movingPath }/moving-in.15-34.png`],
    [IconType.Live_15_35, `${ movingPath }/moving-in.15-35.png`],
    [IconType.Live_16_0, `${ movingPath }/moving-in.16-00.png`],
    [IconType.Live_16_1, `${ movingPath }/moving-in.16-01.png`],
    [IconType.Live_16_2, `${ movingPath }/moving-in.16-02.png`],
    [IconType.Live_16_3, `${ movingPath }/moving-in.16-03.png`],
    [IconType.Live_16_4, `${ movingPath }/moving-in.16-04.png`],
    [IconType.Live_16_5, `${ movingPath }/moving-in.16-05.png`],
    [IconType.Live_16_6, `${ movingPath }/moving-in.16-06.png`],
    [IconType.Live_16_7, `${ movingPath }/moving-in.16-07.png`],
    [IconType.Live_16_8, `${ movingPath }/moving-in.16-08.png`],
    [IconType.Live_16_9, `${ movingPath }/moving-in.16-09.png`],
    [IconType.Live_16_10, `${ movingPath }/moving-in.16-10.png`],
    [IconType.Live_16_11, `${ movingPath }/moving-in.16-11.png`],
    [IconType.Live_16_12, `${ movingPath }/moving-in.16-12.png`],
    [IconType.Live_16_13, `${ movingPath }/moving-in.16-13.png`],
    [IconType.Live_16_14, `${ movingPath }/moving-in.16-14.png`],
    [IconType.Live_16_15, `${ movingPath }/moving-in.16-15.png`],
    [IconType.Live_16_16, `${ movingPath }/moving-in.16-16.png`],
    [IconType.Live_16_17, `${ movingPath }/moving-in.16-17.png`],
    [IconType.Live_16_18, `${ movingPath }/moving-in.16-18.png`],
    [IconType.Live_16_19, `${ movingPath }/moving-in.16-19.png`],
    [IconType.Live_16_20, `${ movingPath }/moving-in.16-20.png`],
    [IconType.Live_16_21, `${ movingPath }/moving-in.16-21.png`],
    [IconType.Live_16_22, `${ movingPath }/moving-in.16-22.png`],
    [IconType.Live_16_23, `${ movingPath }/moving-in.16-23.png`],
    [IconType.Live_16_24, `${ movingPath }/moving-in.16-24.png`],
    [IconType.Live_16_25, `${ movingPath }/moving-in.16-25.png`],
    [IconType.Live_16_26, `${ movingPath }/moving-in.16-26.png`],
    [IconType.Live_16_27, `${ movingPath }/moving-in.16-27.png`],
    [IconType.Live_16_28, `${ movingPath }/moving-in.16-28.png`],
    [IconType.Live_16_29, `${ movingPath }/moving-in.16-29.png`],
    [IconType.Live_16_30, `${ movingPath }/moving-in.16-30.png`],
    [IconType.Live_16_31, `${ movingPath }/moving-in.16-31.png`],
    [IconType.Live_16_32, `${ movingPath }/moving-in.16-32.png`],
    [IconType.Live_16_33, `${ movingPath }/moving-in.16-33.png`],
    [IconType.Live_16_34, `${ movingPath }/moving-in.16-34.png`],
    [IconType.Live_16_35, `${ movingPath }/moving-in.16-35.png`],
    [IconType.Live_17_0, `${ movingPath }/moving-in.17-00.png`],
    [IconType.Live_17_1, `${ movingPath }/moving-in.17-01.png`],
    [IconType.Live_17_2, `${ movingPath }/moving-in.17-02.png`],
    [IconType.Live_17_3, `${ movingPath }/moving-in.17-03.png`],
    [IconType.Live_17_4, `${ movingPath }/moving-in.17-04.png`],
    [IconType.Live_17_5, `${ movingPath }/moving-in.17-05.png`],
    [IconType.Live_17_6, `${ movingPath }/moving-in.17-06.png`],
    [IconType.Live_17_7, `${ movingPath }/moving-in.17-07.png`],
    [IconType.Live_17_8, `${ movingPath }/moving-in.17-08.png`],
    [IconType.Live_17_9, `${ movingPath }/moving-in.17-09.png`],
    [IconType.Live_17_10, `${ movingPath }/moving-in.17-10.png`],
    [IconType.Live_17_11, `${ movingPath }/moving-in.17-11.png`],
    [IconType.Live_17_12, `${ movingPath }/moving-in.17-12.png`],
    [IconType.Live_17_13, `${ movingPath }/moving-in.17-13.png`],
    [IconType.Live_17_14, `${ movingPath }/moving-in.17-14.png`],
    [IconType.Live_17_15, `${ movingPath }/moving-in.17-15.png`],
    [IconType.Live_17_16, `${ movingPath }/moving-in.17-16.png`],
    [IconType.Live_17_17, `${ movingPath }/moving-in.17-17.png`],
    [IconType.Live_17_18, `${ movingPath }/moving-in.17-18.png`],
    [IconType.Live_17_19, `${ movingPath }/moving-in.17-19.png`],
    [IconType.Live_17_20, `${ movingPath }/moving-in.17-20.png`],
    [IconType.Live_17_21, `${ movingPath }/moving-in.17-21.png`],
    [IconType.Live_17_22, `${ movingPath }/moving-in.17-22.png`],
    [IconType.Live_17_23, `${ movingPath }/moving-in.17-23.png`],
    [IconType.Live_17_24, `${ movingPath }/moving-in.17-24.png`],
    [IconType.Live_17_25, `${ movingPath }/moving-in.17-25.png`],
    [IconType.Live_17_26, `${ movingPath }/moving-in.17-26.png`],
    [IconType.Live_17_27, `${ movingPath }/moving-in.17-27.png`],
    [IconType.Live_17_28, `${ movingPath }/moving-in.17-28.png`],
    [IconType.Live_17_29, `${ movingPath }/moving-in.17-29.png`],
    [IconType.Live_17_30, `${ movingPath }/moving-in.17-30.png`],
    [IconType.Live_17_31, `${ movingPath }/moving-in.17-31.png`],
    [IconType.Live_17_32, `${ movingPath }/moving-in.17-32.png`],
    [IconType.Live_17_33, `${ movingPath }/moving-in.17-33.png`],
    [IconType.Live_17_34, `${ movingPath }/moving-in.17-34.png`],
    [IconType.Live_17_35, `${ movingPath }/moving-in.17-35.png`],
    [IconType.Live_18_0, `${ movingPath }/moving-in.18-00.png`],
    [IconType.Live_18_1, `${ movingPath }/moving-in.18-01.png`],
    [IconType.Live_18_2, `${ movingPath }/moving-in.18-02.png`],
    [IconType.Live_18_3, `${ movingPath }/moving-in.18-03.png`],
    [IconType.Live_18_4, `${ movingPath }/moving-in.18-04.png`],
    [IconType.Live_18_5, `${ movingPath }/moving-in.18-05.png`],
    [IconType.Live_18_6, `${ movingPath }/moving-in.18-06.png`],
    [IconType.Live_18_7, `${ movingPath }/moving-in.18-07.png`],
    [IconType.Live_18_8, `${ movingPath }/moving-in.18-08.png`],
    [IconType.Live_18_9, `${ movingPath }/moving-in.18-09.png`],
    [IconType.Live_18_10, `${ movingPath }/moving-in.18-10.png`],
    [IconType.Live_18_11, `${ movingPath }/moving-in.18-11.png`],
    [IconType.Live_18_12, `${ movingPath }/moving-in.18-12.png`],
    [IconType.Live_18_13, `${ movingPath }/moving-in.18-13.png`],
    [IconType.Live_18_14, `${ movingPath }/moving-in.18-14.png`],
    [IconType.Live_18_15, `${ movingPath }/moving-in.18-15.png`],
    [IconType.Live_18_16, `${ movingPath }/moving-in.18-16.png`],
    [IconType.Live_18_17, `${ movingPath }/moving-in.18-17.png`],
    [IconType.Live_18_18, `${ movingPath }/moving-in.18-18.png`],
    [IconType.Live_18_19, `${ movingPath }/moving-in.18-19.png`],
    [IconType.Live_18_20, `${ movingPath }/moving-in.18-20.png`],
    [IconType.Live_18_21, `${ movingPath }/moving-in.18-21.png`],
    [IconType.Live_18_22, `${ movingPath }/moving-in.18-22.png`],
    [IconType.Live_18_23, `${ movingPath }/moving-in.18-23.png`],
    [IconType.Live_18_24, `${ movingPath }/moving-in.18-24.png`],
    [IconType.Live_18_25, `${ movingPath }/moving-in.18-25.png`],
    [IconType.Live_18_26, `${ movingPath }/moving-in.18-26.png`],
    [IconType.Live_18_27, `${ movingPath }/moving-in.18-27.png`],
    [IconType.Live_18_28, `${ movingPath }/moving-in.18-28.png`],
    [IconType.Live_18_29, `${ movingPath }/moving-in.18-29.png`],
    [IconType.Live_18_30, `${ movingPath }/moving-in.18-30.png`],
    [IconType.Live_18_31, `${ movingPath }/moving-in.18-31.png`],
    [IconType.Live_18_32, `${ movingPath }/moving-in.18-32.png`],
    [IconType.Live_18_33, `${ movingPath }/moving-in.18-33.png`],
    [IconType.Live_18_34, `${ movingPath }/moving-in.18-34.png`],
    [IconType.Live_18_35, `${ movingPath }/moving-in.18-35.png`],
    [IconType.Idle_0, `${ idlePath }/idle.00.png`],
    [IconType.Idle_1, `${ idlePath }/idle.01.png`],
    [IconType.Idle_2, `${ idlePath }/idle.02.png`],
    [IconType.Idle_3, `${ idlePath }/idle.03.png`],
    [IconType.Idle_4, `${ idlePath }/idle.04.png`],
    [IconType.Idle_5, `${ idlePath }/idle.05.png`],
    [IconType.Idle_6, `${ idlePath }/idle.06.png`],
    [IconType.Idle_7, `${ idlePath }/idle.07.png`],
    [IconType.Idle_8, `${ idlePath }/idle.08.png`],
    [IconType.Idle_9, `${ idlePath }/idle.09.png`],
    [IconType.Idle_10, `${ idlePath }/idle.10.png`],
    [IconType.Idle_11, `${ idlePath }/idle.11.png`],
    [IconType.Idle_12, `${ idlePath }/idle.12.png`],
    [IconType.Idle_13, `${ idlePath }/idle.13.png`],
    [IconType.Idle_14, `${ idlePath }/idle.14.png`],
    [IconType.Idle_15, `${ idlePath }/idle.15.png`],
    [IconType.Idle_16, `${ idlePath }/idle.16.png`],
    [IconType.Idle_17, `${ idlePath }/idle.17.png`],
    [IconType.Idle_18, `${ idlePath }/idle.18.png`],
    [IconType.Idle_in_0, `${ idlePath }/idle-in.00.png`],
    [IconType.Idle_in_1, `${ idlePath }/idle-in.01.png`],
    [IconType.Idle_in_2, `${ idlePath }/idle-in.02.png`],
    [IconType.Idle_in_3, `${ idlePath }/idle-in.03.png`],
    [IconType.Idle_in_4, `${ idlePath }/idle-in.04.png`],
    [IconType.Idle_in_5, `${ idlePath }/idle-in.05.png`],
    [IconType.Idle_in_6, `${ idlePath }/idle-in.06.png`],
    [IconType.Idle_in_7, `${ idlePath }/idle-in.07.png`],
    [IconType.Idle_in_8, `${ idlePath }/idle-in.08.png`],
    [IconType.Idle_in_9, `${ idlePath }/idle-in.09.png`],
    [IconType.Idle_in_10, `${ idlePath }/idle-in.10.png`],
    [IconType.Idle_in_11, `${ idlePath }/idle-in.11.png`],
    [IconType.Idle_in_12, `${ idlePath }/idle-in.12.png`],
    [IconType.Idle_in_13, `${ idlePath }/idle-in.13.png`],
    [IconType.Idle_in_14, `${ idlePath }/idle-in.14.png`],
    [IconType.Idle_in_15, `${ idlePath }/idle-in.15.png`],
    [IconType.Idle_in_16, `${ idlePath }/idle-in.16.png`],
    [IconType.Idle_in_17, `${ idlePath }/idle-in.17.png`],
    [IconType.Idle_in_18, `${ idlePath }/idle-in.18.png`],
    [IconType.Idle_out_0, `${ idlePath }/idle-out.00.png`],
    [IconType.Idle_out_1, `${ idlePath }/idle-out.01.png`],
    [IconType.Idle_out_2, `${ idlePath }/idle-out.02.png`],
    [IconType.Idle_out_3, `${ idlePath }/idle-out.03.png`],
    [IconType.Idle_out_4, `${ idlePath }/idle-out.04.png`],
    [IconType.Idle_out_5, `${ idlePath }/idle-out.05.png`],
    [IconType.Idle_out_6, `${ idlePath }/idle-out.06.png`],
    [IconType.Idle_out_7, `${ idlePath }/idle-out.07.png`],
    [IconType.Idle_out_8, `${ idlePath }/idle-out.08.png`],
    [IconType.Idle_out_9, `${ idlePath }/idle-out.09.png`],
    [IconType.Idle_out_10, `${ idlePath }/idle-out.10.png`],
    [IconType.Idle_out_11, `${ idlePath }/idle-out.11.png`],
    [IconType.Idle_out_12, `${ idlePath }/idle-out.12.png`],
    [IconType.Idle_out_13, `${ idlePath }/idle-out.13.png`],
    [IconType.Idle_out_14, `${ idlePath }/idle-out.14.png`],
    [IconType.Idle_out_15, `${ idlePath }/idle-out.15.png`],
    [IconType.Idle_out_16, `${ idlePath }/idle-out.16.png`],
    [IconType.Idle_out_17, `${ idlePath }/idle-out.17.png`],
    [IconType.Idle_out_18, `${ idlePath }/idle-out.18.png`],
    [IconType.Reallystale_0, `${ reallyStalePath }/reallystale.00.png`],
    [IconType.Reallystale_1, `${ reallyStalePath }/reallystale.01.png`],
    [IconType.Reallystale_2, `${ reallyStalePath }/reallystale.02.png`],
    [IconType.Reallystale_3, `${ reallyStalePath }/reallystale.03.png`],
    [IconType.Reallystale_4, `${ reallyStalePath }/reallystale.04.png`],
    [IconType.Reallystale_5, `${ reallyStalePath }/reallystale.05.png`],
    [IconType.Reallystale_6, `${ reallyStalePath }/reallystale.06.png`],
    [IconType.Reallystale_7, `${ reallyStalePath }/reallystale.07.png`],
    [IconType.Reallystale_8, `${ reallyStalePath }/reallystale.08.png`],
    [IconType.Reallystale_9, `${ reallyStalePath }/reallystale.09.png`],
    [IconType.Reallystale_10, `${ reallyStalePath }/reallystale.10.png`],
    [IconType.Reallystale_11, `${ reallyStalePath }/reallystale.11.png`],
    [IconType.Reallystale_12, `${ reallyStalePath }/reallystale.12.png`],
    [IconType.Reallystale_13, `${ reallyStalePath }/reallystale.13.png`],
    [IconType.Reallystale_14, `${ reallyStalePath }/reallystale.14.png`],
    [IconType.Reallystale_15, `${ reallyStalePath }/reallystale.15.png`],
    [IconType.Reallystale_16, `${ reallyStalePath }/reallystale.16.png`],
    [IconType.Reallystale_17, `${ reallyStalePath }/reallystale.17.png`],
    [IconType.Reallystale_18, `${ reallyStalePath }/reallystale.18.png`],
    [IconType.Stale_0, `${ stalePath }/stale.00.png`],
    [IconType.Stale_1, `${ stalePath }/stale.01.png`],
    [IconType.Stale_2, `${ stalePath }/stale.02.png`],
    [IconType.Stale_3, `${ stalePath }/stale.03.png`],
    [IconType.Stale_4, `${ stalePath }/stale.04.png`],
    [IconType.Stale_5, `${ stalePath }/stale.05.png`],
    [IconType.Stale_6, `${ stalePath }/stale.06.png`],
    [IconType.Stale_7, `${ stalePath }/stale.07.png`],
    [IconType.Stale_8, `${ stalePath }/stale.08.png`],
    [IconType.Stale_9, `${ stalePath }/stale.09.png`],
    [IconType.Stale_10, `${ stalePath }/stale.10.png`],
    [IconType.Stale_11, `${ stalePath }/stale.11.png`],
    [IconType.Stale_12, `${ stalePath }/stale.12.png`],
    [IconType.Stale_13, `${ stalePath }/stale.13.png`],
    [IconType.Stale_14, `${ stalePath }/stale.14.png`],
    [IconType.Stale_15, `${ stalePath }/stale.15.png`],
    [IconType.Stale_16, `${ stalePath }/stale.16.png`],
    [IconType.Stale_17, `${ stalePath }/stale.17.png`],
    [IconType.Stale_18, `${ stalePath }/stale.18.png`],
    [IconType.Stopped_0, `${ stoppedPath }/stopped.00.png`],
    [IconType.Stopped_1, `${ stoppedPath }/stopped.01.png`],
    [IconType.Stopped_2, `${ stoppedPath }/stopped.02.png`],
    [IconType.Stopped_3, `${ stoppedPath }/stopped.03.png`],
    [IconType.Stopped_4, `${ stoppedPath }/stopped.04.png`],
    [IconType.Stopped_5, `${ stoppedPath }/stopped.05.png`],
    [IconType.Stopped_6, `${ stoppedPath }/stopped.06.png`],
    [IconType.Stopped_7, `${ stoppedPath }/stopped.07.png`],
    [IconType.Stopped_8, `${ stoppedPath }/stopped.08.png`],
    [IconType.Stopped_9, `${ stoppedPath }/stopped.09.png`],
    [IconType.Stopped_10, `${ stoppedPath }/stopped.10.png`],
    [IconType.Stopped_11, `${ stoppedPath }/stopped.11.png`],
    [IconType.Stopped_12, `${ stoppedPath }/stopped.12.png`],
    [IconType.Stopped_13, `${ stoppedPath }/stopped.13.png`],
    [IconType.Stopped_14, `${ stoppedPath }/stopped.14.png`],
    [IconType.Stopped_15, `${ stoppedPath }/stopped.15.png`],
    [IconType.Stopped_16, `${ stoppedPath }/stopped.16.png`],
    [IconType.Stopped_17, `${ stoppedPath }/stopped.17.png`],
    [IconType.Stopped_18, `${ stoppedPath }/stopped.18.png`],
    [IconType.Stopped_in_0, `${ stoppedPath }/stopped-in.00.png`],
    [IconType.Stopped_in_1, `${ stoppedPath }/stopped-in.01.png`],
    [IconType.Stopped_in_2, `${ stoppedPath }/stopped-in.02.png`],
    [IconType.Stopped_in_3, `${ stoppedPath }/stopped-in.03.png`],
    [IconType.Stopped_in_4, `${ stoppedPath }/stopped-in.04.png`],
    [IconType.Stopped_in_5, `${ stoppedPath }/stopped-in.05.png`],
    [IconType.Stopped_in_6, `${ stoppedPath }/stopped-in.06.png`],
    [IconType.Stopped_in_7, `${ stoppedPath }/stopped-in.07.png`],
    [IconType.Stopped_in_8, `${ stoppedPath }/stopped-in.08.png`],
    [IconType.Stopped_in_9, `${ stoppedPath }/stopped-in.09.png`],
    [IconType.Stopped_in_10, `${ stoppedPath }/stopped-in.10.png`],
    [IconType.Stopped_in_11, `${ stoppedPath }/stopped-in.11.png`],
    [IconType.Stopped_in_12, `${ stoppedPath }/stopped-in.12.png`],
    [IconType.Stopped_in_13, `${ stoppedPath }/stopped-in.13.png`],
    [IconType.Stopped_in_14, `${ stoppedPath }/stopped-in.14.png`],
    [IconType.Stopped_in_15, `${ stoppedPath }/stopped-in.15.png`],
    [IconType.Stopped_in_16, `${ stoppedPath }/stopped-in.16.png`],
    [IconType.Stopped_in_17, `${ stoppedPath }/stopped-in.17.png`],
    [IconType.Stopped_in_18, `${ stoppedPath }/stopped-in.18.png`],
    [IconType.Stopped_out_0, `${ stoppedPath }/stopped-out.00.png`],
    [IconType.Stopped_out_1, `${ stoppedPath }/stopped-out.01.png`],
    [IconType.Stopped_out_2, `${ stoppedPath }/stopped-out.02.png`],
    [IconType.Stopped_out_3, `${ stoppedPath }/stopped-out.03.png`],
    [IconType.Stopped_out_4, `${ stoppedPath }/stopped-out.04.png`],
    [IconType.Stopped_out_5, `${ stoppedPath }/stopped-out.05.png`],
    [IconType.Stopped_out_6, `${ stoppedPath }/stopped-out.06.png`],
    [IconType.Stopped_out_7, `${ stoppedPath }/stopped-out.07.png`],
    [IconType.Stopped_out_8, `${ stoppedPath }/stopped-out.08.png`],
    [IconType.Stopped_out_9, `${ stoppedPath }/stopped-out.09.png`],
    [IconType.Stopped_out_10, `${ stoppedPath }/stopped-out.10.png`],
    [IconType.Stopped_out_11, `${ stoppedPath }/stopped-out.11.png`],
    [IconType.Stopped_out_12, `${ stoppedPath }/stopped-out.12.png`],
    [IconType.Stopped_out_13, `${ stoppedPath }/stopped-out.13.png`],
    [IconType.Stopped_out_14, `${ stoppedPath }/stopped-out.14.png`],
    [IconType.Stopped_out_15, `${ stoppedPath }/stopped-out.15.png`],
    [IconType.Stopped_out_16, `${ stoppedPath }/stopped-out.16.png`],
    [IconType.Stopped_out_17, `${ stoppedPath }/stopped-out.17.png`],
    [IconType.Stopped_out_18, `${ stoppedPath }/stopped-out.18.png`],
    [IconType.Asset, `${ assetPath }/asset.png`],
    [IconType.AssetUnlabeled, `${ assetPath }/assetUnlabeled.png`]
]);

const iconLinksVWC = new Map<IconType, string>( [
    [IconType.ActiveTrafficCamNorth, `${ trafficCamActive }/active-traffic-cam-north.png`],
    [IconType.ActiveTrafficCamSouth, `${ trafficCamActive }/active-traffic-cam-south.png`],
    [IconType.ActiveTrafficCamEast, `${ trafficCamActive }/active-traffic-cam-east.png`],
    [IconType.ActiveTrafficCamWest, `${ trafficCamActive }/active-traffic-cam-west.png`],
    [IconType.ActiveTrafficCamNA, `${ trafficCamActive }/active-traffic-cam-no-direction.png`],
    [IconType.InactiveTrafficCamNorth, `${ trafficCamInactive }/inactive-traffic-cam-north.png`],
    [IconType.InactiveTrafficCamSouth, `${ trafficCamInactive }/inactive-traffic-cam-south.png`],
    [IconType.InactiveTrafficCamEast, `${ trafficCamInactive }/inactive-traffic-cam-east.png`],
    [IconType.InactiveTrafficCamWest, `${ trafficCamInactive }/inactive-traffic-cam-west.png`],
    [IconType.InactiveTrafficCamNA, `${ trafficCamInactive }/inactive-traffic-cam-no-direction.png`],
    [IconType.VirtualCamNA, `${ virtualCamPath }/virtual-cam-no-direction.png`],
    [IconType.VirtualCamNorth, `${ virtualCamPath }/virtual-cam-north.png`],
    [IconType.VirtualCamEast, `${ virtualCamPath }/virtual-cam-east.png`],
    [IconType.VirtualCamSouth, `${ virtualCamPath }/virtual-cam-south.png`],
    [IconType.VirtualCamWest, `${ virtualCamPath }/virtual-cam-west.png`]
]);

const iconLinksRisk = new Map<IconType, string>( [
    [IconType.RiskLevel, `${ riskPath }/risk-level-tiny-icons.png`],
]);

export { iconLinks1, iconLinks2, iconLinks3, iconLinksRisk, iconLinksVWC };
